import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = ({ style }) => (
  <path
    style={style}
    d="M47.93,25.46c-0.01,0.15-0.02,0.31-0.03,0.47C47.06,36.48,39.4,45.11,29.33,47.4
c-0.58,0.13-1.17,0.24-1.77,0.33C26.4,47.91,25.2,48,23.99,48c-1.67,0-3.31-0.17-4.89-0.5l-6.29-9.78l0.14-5.31L32.3,8.21
L47.93,25.46z"
  />
);

const JackSparrowAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.jackSparrow}
    renderShadow={renderShadow}
  >
    <>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M29.87,31.39c0.33-1.03,0.28-3.08,0.17-4.16l2.95-3.21l0.22,5.48L29.87,31.39z"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M30.16,31.47c0.41-1.32,0.32-2.88,0.18-4.24c-0.03,0.07-0.06,0.14-0.09,0.21c0.98-1.07,1.97-2.14,2.95-3.21
			c-0.17-0.07-0.34-0.14-0.51-0.21c0.07,1.83,0.14,3.65,0.22,5.48c0.05-0.09,0.1-0.17,0.15-0.26c-1.11,0.63-2.22,1.27-3.34,1.9
			c-0.34,0.19-0.03,0.71,0.3,0.52c1.11-0.63,2.22-1.27,3.34-1.9c0.09-0.05,0.15-0.16,0.15-0.26c-0.07-1.83-0.14-3.65-0.22-5.48
			c-0.01-0.25-0.33-0.41-0.51-0.21c-0.61,0.67-1.23,1.34-1.84,2.01c-0.33,0.36-0.65,0.71-0.98,1.07c-0.09,0.09-0.18,0.18-0.21,0.31
			c-0.03,0.15,0.02,0.34,0.03,0.5c0.02,0.23,0.03,0.45,0.03,0.68c0.03,0.97,0.05,2.01-0.23,2.94
			C29.47,31.68,30.05,31.84,30.16,31.47z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M12.9,29.55c0.11,2.41,0.07,4.82-0.13,7.23c-0.03,0.31-0.05,0.64,0.03,0.94c0.09,0.3,0.31,0.59,0.62,0.66
		c0.43,0.09,0.84-0.24,1.05-0.61c0.45-0.79,0.34-1.75,0.18-2.64c-0.33-1.81-0.87-3.61-1.86-5.17"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M12.6,29.55c0.07,1.52,0.08,3.04,0.03,4.56c-0.03,0.75-0.07,1.49-0.12,2.24c-0.04,0.59-0.17,1.26,0.16,1.79
			c0.65,1.07,1.87,0.36,2.23-0.55c0.45-1.13,0.1-2.46-0.16-3.59c-0.34-1.47-0.87-2.9-1.67-4.19c-0.2-0.33-0.72-0.03-0.52,0.3
			c0.75,1.2,1.24,2.52,1.57,3.9c0.26,1.06,0.89,3.09-0.16,3.92c-0.36,0.29-0.73,0.13-0.86-0.29c-0.12-0.37-0.02-0.83,0.01-1.2
			c0.06-0.74,0.1-1.49,0.13-2.23c0.06-1.55,0.04-3.1-0.03-4.65C13.18,29.16,12.58,29.16,12.6,29.55L12.6,29.55z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M11.96,26.75c-0.34-0.04-0.58,0.31-0.74,0.61c-0.34,0.67-0.68,1.52-0.21,2.11c0.15,0.19,0.37,0.33,0.52,0.53
		c0.22,0.3,0.24,0.72,0.11,1.07c-0.13,0.35-0.39,0.64-0.68,0.88c-0.18,0.15-0.38,0.29-0.52,0.48s-0.21,0.45-0.11,0.66
		c0.14,0.29,0.53,0.36,0.76,0.59c0.3,0.3,0.22,0.83-0.04,1.16c-0.27,0.33-0.68,0.51-1.07,0.68c0.66-0.13,1.35-0.35,1.78-0.86
		c0.23-0.27,0.38-0.61,0.5-0.94c0.43-1.14,0.69-2.34,0.63-3.55c-0.06-1.21-0.46-2.42-1.25-3.35"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M11.96,26.45c-0.88,0.01-1.33,1.27-1.44,1.98c-0.07,0.42-0.01,0.85,0.24,1.19c0.32,0.44,0.83,0.65,0.62,1.3
			c-0.25,0.78-1.82,1.32-1.29,2.31c0.19,0.36,0.78,0.43,0.89,0.8c0.19,0.65-0.69,1.02-1.14,1.21c-0.33,0.14-0.08,0.61,0.23,0.55
			c0.78-0.16,1.58-0.44,2.06-1.12c0.56-0.8,0.83-1.93,0.97-2.88c0.29-1.85-0.04-3.73-1.24-5.21c-0.24-0.3-0.67,0.13-0.42,0.42
			c1.05,1.29,1.33,3.01,1.08,4.62c-0.12,0.81-0.34,1.68-0.72,2.41c-0.38,0.75-1.11,1.01-1.89,1.17c0.08,0.18,0.15,0.37,0.23,0.55
			c0.74-0.33,1.68-0.92,1.42-1.89c-0.1-0.38-0.4-0.55-0.71-0.74c-0.65-0.4,0.31-0.92,0.6-1.22c0.57-0.6,0.84-1.55,0.22-2.23
			c-0.15-0.16-0.35-0.29-0.47-0.48c-0.16-0.27-0.13-0.6-0.05-0.89c0.08-0.33,0.37-1.28,0.81-1.28
			C12.35,27.05,12.35,26.45,11.96,26.45L11.96,26.45z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#E5CEA5' }}
          d="M14.56,33.47c-0.04,0.12-0.6,0.09-0.72,0.1c-0.38,0.02-0.62,0.04-1,0.02c-0.1-0.01-0.19-0.08-0.19-0.19
		c0-0.26-0.01-0.62,0.02-0.8c0.02-0.13,0.1-0.34,0.22-0.38c0.09-0.03,0.19-0.03,0.28-0.03c0.25-0.01,0.51,0.01,0.75,0.06
		c0.1,0.02,0.2,0.05,0.28,0.12C14.3,32.49,14.6,33.33,14.56,33.47z"
        />
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M31.63,37.08c-0.05,1.11-0.08,2.27,0.43,3.26c0.16,0.32,0.45,0.64,0.82,0.61c0.21-0.02,0.39-0.16,0.53-0.32
		c0.62-0.66,0.8-1.61,0.8-2.51c0-0.44,0.07-8.28,0.35-8.63"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M31.33,37.08c-0.04,0.93-0.07,1.9,0.22,2.8c0.19,0.6,0.61,1.44,1.37,1.36c0.71-0.08,1.16-0.94,1.36-1.53
			c0.19-0.56,0.23-1.15,0.24-1.74c0.02-1.98,0.05-3.97,0.12-5.95c0.02-0.54,0.04-1.09,0.09-1.63c0.01-0.17,0.02-0.35,0.05-0.52
			c0.01-0.08,0.06-0.26,0.04-0.23c0.21-0.33-0.31-0.63-0.52-0.3c-0.24,0.37-0.18,1.06-0.2,1.47c-0.06,0.97-0.09,1.93-0.11,2.9
			c-0.04,1.53-0.02,3.06-0.07,4.59c-0.02,0.5-0.09,1-0.3,1.46c-0.23,0.51-0.8,1.24-1.26,0.49c-0.56-0.91-0.47-2.15-0.43-3.17
			C31.94,36.7,31.34,36.7,31.33,37.08L31.33,37.08z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M37.23,33.86c-0.09,0.51-0.02,1.04,0.18,1.51c0.15,0.34,0.37,0.66,0.48,1.01c0.11,0.38,0.1,0.79-0.05,1.15
		c-0.13,0.31-0.39,0.61-0.73,0.6c-0.32,0-0.58-0.28-0.67-0.58c-0.09-0.3-0.03-0.62,0.02-0.93"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M36.94,33.78c-0.08,0.54-0.05,1.09,0.15,1.6c0.19,0.48,0.55,0.91,0.57,1.44c0.01,0.32-0.11,1-0.54,1.02
			c-0.18,0.01-0.32-0.16-0.38-0.31c-0.1-0.26-0.04-0.57,0-0.83c0.06-0.38-0.52-0.54-0.58-0.16c-0.1,0.63-0.14,1.35,0.46,1.75
			c0.53,0.35,1.15,0.01,1.42-0.5c0.32-0.61,0.25-1.3-0.04-1.91c-0.14-0.29-0.32-0.57-0.41-0.89c-0.1-0.34-0.13-0.71-0.08-1.06
			c0.03-0.16-0.04-0.32-0.21-0.37C37.17,33.53,36.97,33.62,36.94,33.78L36.94,33.78z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M17.61,26.9c-0.05-0.04-0.1-0.09-0.15-0.14c-0.02-0.02-0.04-0.04-0.06-0.07c-0.01-0.01-0.02-0.03-0.04-0.04
			c-0.03-0.03,0.03,0.04,0.01,0.01c-0.04-0.06-0.08-0.11-0.11-0.17c-0.02-0.03-0.03-0.06-0.05-0.09c-0.01-0.01-0.01-0.03-0.02-0.04
			c-0.02-0.05,0.01,0.03,0,0c-0.04-0.12-0.1-0.25-0.1-0.38c0,0.02,0.01,0.05,0,0.01c0-0.02,0-0.04,0-0.06c0-0.03,0-0.06,0-0.09
			c0-0.07,0-0.14,0.01-0.22c0.02-0.16-0.15-0.31-0.3-0.3c-0.18,0.01-0.28,0.13-0.3,0.3c-0.08,0.63,0.2,1.31,0.7,1.71
			c0.12,0.1,0.31,0.13,0.42,0C17.71,27.21,17.74,27,17.61,26.9L17.61,26.9z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#AD7953' }}
            d="M17.76,37.4c0.05,0.67-0.04,1.31-0.28,1.95c-0.05,0.14,0.05,0.3,0.17,0.35c0.13,0.05,0.3,0.01,0.37-0.12
			c0.32-0.59,0.69-1.14,1.13-1.64c0.08-0.09,0.11-0.21,0.06-0.33c-0.05-0.1-0.15-0.19-0.27-0.18c-0.23,0.01-0.43-0.04-0.63-0.16
			c-0.14-0.09-0.33-0.03-0.41,0.11c-0.08,0.14-0.03,0.32,0.11,0.41c0.28,0.17,0.61,0.26,0.93,0.24c-0.07-0.17-0.14-0.34-0.21-0.51
			c-0.47,0.54-0.89,1.13-1.23,1.77c0.18,0.08,0.37,0.15,0.55,0.23c0.25-0.67,0.36-1.39,0.3-2.1c-0.01-0.16-0.13-0.3-0.3-0.3
			C17.91,37.1,17.75,37.24,17.76,37.4L17.76,37.4z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M32.42,20.7c-0.11,2.47-0.21,4.94-0.6,7.37c-0.24,1.47-0.58,2.92-1.11,4.32c-0.28,0.73-0.61,1.44-0.91,2.17
		c-0.77,1.86-0.48,3.8-0.79,5.78l-0.83,0.04c-0.38,0.19-0.84,0.23-1.24,0.1c0.59-0.56,1.25-0.87,1.59-1.6l0.23-0.76
		c-0.16,0.09-0.79-0.29-0.74-0.47c0.18-0.68,0.56-1.31,1.09-1.79l1.83-3.25l-1.04,7.43"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M32.12,20.7c-0.15,3.53-0.27,7.15-1.34,10.56c-0.45,1.43-1.24,2.76-1.59,4.21c-0.38,1.56-0.25,3.2-0.48,4.79
			c0.1-0.07,0.19-0.15,0.29-0.22c-0.6,0.03-1.45,0.26-1.99,0.15c0.04,0.17,0.09,0.33,0.13,0.5c0.54-0.48,1.21-0.88,1.57-1.53
			c0.16-0.3,0.24-0.64,0.33-0.96c0.05-0.18-0.1-0.39-0.29-0.38c-1.02,0.07,0.45-1.6,0.63-1.85c0.22-0.31,0.38-0.68,0.57-1
			c0.41-0.73,0.83-1.47,1.24-2.2c-0.18-0.08-0.37-0.15-0.55-0.23c-0.35,2.48-0.69,4.95-1.04,7.43c-0.05,0.38,0.53,0.54,0.58,0.16
			c0.35-2.48,0.69-4.95,1.04-7.43c0.04-0.31-0.37-0.55-0.55-0.23c-0.57,1.01-1.07,2.13-1.74,3.08c-0.4,0.57-1.22,1.26-1.21,2.03
			c0,0.5,0.55,0.88,1.03,0.85c-0.1-0.13-0.19-0.25-0.29-0.38c-0.32,1.05-0.94,1.51-1.75,2.23c-0.16,0.15-0.08,0.46,0.13,0.5
			c0.74,0.16,1.41-0.09,2.15-0.12c0.12-0.01,0.27-0.09,0.29-0.22c0.23-1.58,0.1-3.23,0.48-4.79c0.38-1.57,1.25-3.01,1.7-4.57
			c0.98-3.35,1.11-6.89,1.25-10.36C32.73,20.31,32.14,20.31,32.12,20.7L32.12,20.7z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M32.12,27.93c-0.48,0.77-0.96,1.54-1.44,2.32c-0.12,0.19-1.21,1.18-1.51,1.77c-0.29,0.59,0.06,1.44,0.72,1.55"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M31.86,27.78c-0.25,0.4-0.5,0.8-0.75,1.2c-0.23,0.37-0.44,0.76-0.69,1.11c-0.02,0.02,0.02-0.02-0.03,0.03
			c-0.03,0.03-0.06,0.06-0.08,0.09c-0.08,0.09-0.17,0.17-0.25,0.26c-0.2,0.21-0.41,0.42-0.6,0.64c-0.36,0.42-0.73,0.87-0.69,1.46
			c0.05,0.59,0.44,1.15,1.04,1.27c0.38,0.08,0.54-0.5,0.16-0.58c-0.48-0.1-0.74-0.66-0.54-1.1c0.18-0.42,0.58-0.78,0.89-1.1
			c0.29-0.31,0.56-0.58,0.79-0.95c0.42-0.68,0.85-1.36,1.27-2.04C32.59,27.76,32.07,27.45,31.86,27.78L31.86,27.78z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M33.99,18.19c1.08,0.11,2,0.89,2.48,1.84c0.48,0.95,0.56,2.05,0.47,3.11c-0.03,0.33-0.07,0.66-0.01,0.98
		c0.11,0.61,0.58,1.12,1.15,1.37c0.29,0.13,0.64,0.19,0.93,0.06c0.29-0.12,0.49-0.48,0.35-0.76c0.17,0.46-0.18,0.96-0.61,1.2
		c-0.59,0.32-1.35,0.31-1.96,0.02c-0.61-0.29-1.07-0.84-1.3-1.47c-0.33-0.91-0.2-1.91-0.27-2.88c-0.09-1.1-0.47-2.19-1.1-3.11"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M33.99,18.49c1.03,0.13,1.86,0.9,2.28,1.82c0.24,0.54,0.36,1.13,0.39,1.72c0.03,0.59-0.07,1.16-0.06,1.74
			c0.01,0.9,0.57,1.67,1.4,2c0.39,0.16,0.87,0.22,1.25-0.02c0.36-0.22,0.54-0.66,0.39-1.05c-0.13-0.36-0.69-0.22-0.58,0.16
			c0.14,0.48-0.34,0.85-0.75,0.98c-0.45,0.14-0.95,0.1-1.38-0.1c-0.87-0.41-1.28-1.3-1.36-2.21c-0.08-0.89,0-1.79-0.18-2.68
			c-0.17-0.88-0.53-1.71-1.03-2.45c-0.21-0.32-0.73-0.02-0.52,0.3c0.67,1.01,1.04,2.16,1.08,3.37c0.03,1.09-0.05,2.24,0.59,3.19
			c0.55,0.83,1.49,1.35,2.5,1.25c0.88-0.09,1.91-0.81,1.62-1.81c-0.19,0.05-0.39,0.11-0.58,0.16c0.12,0.32-0.22,0.47-0.49,0.45
			c-0.23-0.02-0.45-0.12-0.65-0.24c-0.33-0.21-0.61-0.54-0.7-0.93c-0.12-0.5,0.02-1.05,0.03-1.56c0.01-0.47-0.02-0.93-0.11-1.39
			c-0.3-1.64-1.46-3.09-3.17-3.3C33.61,17.84,33.61,18.44,33.99,18.49L33.99,18.49z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M18.77,8.46c-0.01-0.81-0.81-1.49-1.64-1.52s-1.62,0.47-2.09,1.14c-0.47,0.67-0.66,1.5-0.73,2.31
		c-0.03,0.32-0.04,0.65-0.01,0.97c0.04,0.35,0.12,0.7,0.26,1.03c0.3,0.11,0.57-0.2,0.74-0.47c0.53-0.85,1.06-1.7,1.58-2.56
		c0.21-0.33,0.42-0.68,0.74-0.92c0.32-0.24,0.76-0.36,1.12-0.2"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M19.07,8.46c-0.04-0.99-0.91-1.74-1.87-1.81c-1.06-0.09-2.05,0.63-2.57,1.52c-0.57,0.98-0.77,2.31-0.61,3.42
			c0.04,0.29,0.12,0.57,0.23,0.84c0.1,0.26,0.34,0.33,0.61,0.26c0.54-0.14,0.83-0.82,1.09-1.25c0.4-0.64,0.79-1.28,1.19-1.92
			c0.32-0.52,0.81-1.25,1.52-0.98c0.36,0.14,0.52-0.44,0.16-0.58c-1.06-0.41-1.8,0.62-2.28,1.39c-0.31,0.5-0.62,1-0.93,1.51
			c-0.15,0.24-0.3,0.49-0.45,0.73c-0.09,0.14-0.29,0.57-0.51,0.51c0.07,0.07,0.14,0.14,0.21,0.21c-0.31-0.76-0.32-1.57-0.19-2.38
			c0.12-0.72,0.36-1.45,0.87-1.99c0.45-0.46,1.11-0.81,1.77-0.68c0.58,0.11,1.14,0.58,1.16,1.2C18.48,8.85,19.08,8.85,19.07,8.46
			L19.07,8.46z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M18.14,6.92c0.36-0.56,0.76-1.13,1.33-1.49c0.57-0.36,1.36-0.47,1.92-0.1c0.51,0.33,0.72,0.96,0.79,1.55
		c0,0.03,0.01,0.06-0.01,0.09c-0.03,0.05-0.1,0.06-0.16,0.06c-1.26,0-2.35,1.04-3.6,0.95c-0.08-0.01-0.18-0.02-0.23-0.09
		c-0.03-0.05-0.04-0.11-0.04-0.16c-0.02-0.31,0-0.62,0.05-0.93"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M18.4,7.07c0.36-0.57,0.77-1.16,1.39-1.47c0.53-0.27,1.24-0.29,1.67,0.18c0.2,0.22,0.31,0.51,0.38,0.8
			c0.02,0.07,0.03,0.14,0.04,0.21c0-0.02,0.01,0.1,0.01,0.1c0.03,0.01,0.12-0.16,0.13-0.15c-0.03-0.05-0.45,0.04-0.51,0.05
			C20.88,6.89,20.3,7.2,19.7,7.43c-0.31,0.12-0.64,0.23-0.98,0.25c-0.09,0.01-0.19-0.01-0.27,0c-0.02,0-0.09-0.02-0.03,0.02
			c0.05,0.04,0.02-0.08,0.02-0.13c-0.01-0.23,0.01-0.47,0.05-0.7c0.06-0.38-0.52-0.54-0.58-0.16c-0.04,0.26-0.07,0.52-0.07,0.78
			c0,0.22-0.01,0.48,0.17,0.64c0.29,0.26,0.87,0.14,1.21,0.07c0.79-0.18,1.49-0.63,2.27-0.82c0.34-0.08,0.98,0.03,1-0.47
			c0.01-0.39-0.15-0.84-0.33-1.18c-0.41-0.77-1.25-1.07-2.08-0.89c-1.01,0.22-1.67,1.08-2.2,1.91C17.67,7.1,18.19,7.4,18.4,7.07
			L18.4,7.07z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M21.8,5.16c0.76-0.62,1.79-0.86,2.77-0.82s1.94,0.35,2.84,0.75c1.47,0.65,2.89,1.59,3.64,2.99
		c-0.66,0.41-1.52,0.18-2.26-0.07c-1.71-0.57-3.42-1.15-5.13-1.72c-0.56-0.19-1.12-0.37-1.7-0.43"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M21.96,5.42c1.47-1.14,3.39-0.85,5.01-0.2c1.53,0.62,3.02,1.53,3.84,3.01c0.04-0.14,0.07-0.27,0.11-0.41
			c-0.7,0.39-1.51,0.07-2.2-0.16c-0.74-0.25-1.48-0.5-2.22-0.74c-1.47-0.49-2.98-1.17-4.52-1.36c-0.38-0.05-0.38,0.55,0,0.6
			c0.91,0.11,1.79,0.48,2.65,0.77c0.8,0.27,1.6,0.53,2.4,0.8c0.76,0.25,1.51,0.55,2.28,0.75c0.66,0.17,1.31,0.2,1.92-0.13
			c0.14-0.08,0.18-0.27,0.11-0.41c-0.89-1.62-2.53-2.61-4.2-3.28c-1.75-0.7-3.88-0.97-5.47,0.26C21.35,5.13,21.65,5.65,21.96,5.42
			L21.96,5.42z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M30.04,7.9c0.77-0.08,1.62-0.14,2.26,0.3c0.22,0.15,0.39,0.35,0.53,0.57c0.17,0.27,0.29,0.57,0.35,0.88
		c0.03,0.14,0.04,0.29-0.03,0.41c-0.05,0.08-0.12,0.14-0.2,0.18c-0.62,0.37-1.46,0.22-2.03-0.21c-0.58-0.43-0.93-1.09-1.18-1.75"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M30.04,8.2c0.52-0.05,1.07-0.11,1.59,0.03c0.53,0.14,0.9,0.52,1.11,1.02c0.05,0.12,0.09,0.25,0.12,0.38
			c0.02,0.09,0.07,0.23,0.01,0.31c-0.11,0.16-0.44,0.22-0.61,0.23c-0.48,0.03-0.96-0.15-1.32-0.47c-0.44-0.39-0.72-0.93-0.93-1.48
			c-0.06-0.15-0.2-0.26-0.37-0.21c-0.15,0.04-0.27,0.22-0.21,0.37C29.69,9,30,9.61,30.49,10.08c0.47,0.44,1.11,0.72,1.76,0.68
			c0.31-0.02,0.64-0.1,0.9-0.28c0.35-0.23,0.4-0.58,0.32-0.97c-0.14-0.67-0.56-1.34-1.17-1.67c-0.69-0.37-1.5-0.32-2.25-0.24
			c-0.16,0.02-0.3,0.13-0.3,0.3C29.74,8.05,29.88,8.22,30.04,8.2L30.04,8.2z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M14.72,9.22c-1,1.08-1.75,2.39-2.15,3.79c-0.31,1.06-0.42,2.16-0.54,3.25c-0.25,2.37-0.5,4.75-0.53,7.13
		c-0.01,0.76,0.01,1.52,0.15,2.27c0.12,0.69,0.35,1.35,0.58,2.01c1.19,3.31,2.74,6.54,3.21,10.01c0.14,1,0.33,2.22,1.3,2.57
		c0.1,0.04,0.22,0.06,0.32,0.03c0.12-0.03,0.21-0.13,0.28-0.23c0.65-0.92,0.51-2.16,0.29-3.27c-0.41-2.1-1-4.16-1.75-6.17
		c-0.3-0.81-0.63-1.61-0.9-2.44c-0.85-2.59-1.1-5.36-0.72-8.06c0.12-0.85,0.3-1.68,0.42-2.53c0.39-2.7,0.22-5.44,0.04-8.16"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M14.51,9.01c-2.99,3.37-3.02,8.2-3.25,12.48c-0.13,2.38,0.01,4.44,0.84,6.69c0.82,2.22,1.77,4.4,2.43,6.69
			c0.3,1.06,0.49,2.12,0.67,3.2c0.12,0.69,0.26,1.44,0.75,1.98c0.98,1.08,1.85,0.23,2.1-0.93c0.4-1.88-0.47-4.2-1-5.97
			c-0.68-2.29-1.74-4.46-2.25-6.79c-0.65-2.98-0.26-5.71,0.18-8.68c0.4-2.73,0.23-5.5,0.06-8.24c-0.02-0.38-0.62-0.39-0.6,0
			c0.13,2.08,0.27,4.17,0.15,6.25c-0.12,2.03-0.66,3.99-0.76,6.02c-0.09,1.84,0.1,3.69,0.56,5.47c0.5,1.94,1.37,3.78,1.96,5.69
			c0.54,1.76,1.35,3.94,1.17,5.8c-0.04,0.44-0.19,1.41-1.04,1.06c-0.17-0.07-0.33-0.5-0.39-0.65c-0.14-0.33-0.2-0.67-0.27-1.02
			c-0.18-0.98-0.32-1.95-0.58-2.92c-1.05-3.92-3.45-7.61-3.43-11.75c0.01-2.3,0.26-4.6,0.5-6.89c0.28-2.67,0.8-5.01,2.63-7.07
			C15.19,9.15,14.76,8.72,14.51,9.01L14.51,9.01z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M12.12,16.33c-0.46,1.07-1.41,1.95-1.61,3.09c-0.04,0.22-0.04,0.47,0.12,0.64c0.07,0.08,0.16,0.13,0.25,0.19
		c0.37,0.3,0.38,0.87,0.21,1.31s-0.49,0.82-0.69,1.25c-0.06,0.12-0.11,0.26-0.08,0.39c0.06,0.36,0.54,0.46,0.91,0.46"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M11.86,16.17c-0.35,0.8-0.94,1.47-1.33,2.25c-0.17,0.35-0.32,0.74-0.34,1.14c-0.02,0.41,0.15,0.63,0.44,0.88
			c0.78,0.67-0.35,1.71-0.58,2.37c-0.27,0.8,0.51,1.11,1.16,1.14c0.39,0.02,0.39-0.58,0-0.6c-0.32-0.01-0.73-0.05-0.55-0.46
			c0.16-0.34,0.4-0.64,0.57-0.98c0.27-0.54,0.39-1.24-0.02-1.75c-0.1-0.12-0.24-0.19-0.34-0.3c-0.12-0.14-0.1-0.31-0.06-0.49
			c0.07-0.36,0.23-0.69,0.42-1.01c0.37-0.64,0.84-1.22,1.14-1.91C12.53,16.13,12.01,15.82,11.86,16.17L11.86,16.17z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M17.19,40.23c0.02,0.67,0.03,1.34,0.05,2.01c0,0.18,0.01,0.38,0.11,0.53c0.17,0.28,0.57,0.35,0.87,0.24
		c0.31-0.11,0.53-0.37,0.71-0.64c0.93-1.4,0.86-3.23,0.5-4.86"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M16.89,40.23c0.01,0.53,0.02,1.06,0.04,1.58c0.01,0.43-0.05,0.95,0.29,1.27c0.64,0.63,1.51,0.08,1.93-0.5
			c1.05-1.49,0.94-3.47,0.58-5.16c-0.08-0.38-0.66-0.22-0.58,0.16c0.29,1.35,0.42,2.88-0.2,4.17c-0.14,0.29-0.31,0.59-0.56,0.81
			c-0.18,0.16-0.53,0.31-0.74,0.1c-0.13-0.13-0.1-0.37-0.1-0.53c0-0.21-0.01-0.42-0.01-0.63c-0.01-0.42-0.02-0.84-0.03-1.27
			C17.49,39.84,16.89,39.84,16.89,40.23L16.89,40.23z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M17.43,27.08c-0.34,1.49-0.67,3.12-0.01,4.51c0.32,0.67,0.85,1.24,1.14,1.92c0.38,0.93,0.27,2-0.03,2.96
		c-0.05,0.16-0.1,0.32-0.07,0.48c0.06,0.35,0.51,0.53,0.86,0.42c0.34-0.11,0.58-0.42,0.72-0.75c0.55-1.25,0.02-2.69-0.62-3.9
		c-0.63-1.21-1.39-2.47-1.28-3.83c0.04-0.42,0.16-0.85,0.1-1.27c-0.06-0.42-0.38-0.86-0.82-0.85"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M17.14,27c-0.38,1.67-0.72,3.48,0.18,5.04c0.49,0.85,1.12,1.55,1.17,2.58c0.02,0.45-0.03,0.9-0.14,1.34
			c-0.09,0.36-0.28,0.75-0.17,1.13c0.15,0.53,0.8,0.72,1.28,0.54c0.65-0.24,0.97-0.99,1.06-1.63c0.27-1.79-0.89-3.33-1.59-4.87
			c-0.21-0.46-0.39-0.94-0.47-1.44c-0.09-0.55,0.03-1.06,0.07-1.61c0.06-0.76-0.3-1.52-1.13-1.6c-0.38-0.04-0.38,0.56,0,0.6
			c0.74,0.07,0.51,1.1,0.45,1.56c-0.04,0.35-0.05,0.69,0,1.04c0.11,0.79,0.43,1.53,0.79,2.24c0.43,0.84,0.92,1.65,1.16,2.56
			c0.11,0.42,0.18,0.87,0.13,1.31c-0.05,0.44-0.26,1.25-0.8,1.3c-0.66,0.07-0.22-0.91-0.16-1.24c0.07-0.38,0.12-0.76,0.11-1.14
			c-0.02-0.81-0.3-1.51-0.74-2.18c-0.53-0.81-0.96-1.54-1.01-2.52c-0.05-0.96,0.16-1.92,0.37-2.85C17.8,26.78,17.23,26.62,17.14,27
			L17.14,27z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M16.87,27.78c0.04-0.26,0-0.54-0.12-0.77c-0.01,1.9,0.35,3.81,1.07,5.58c0.4,0.98,0.91,1.95,0.93,3.01
		c0.01,0.68-0.34,1.49-1.03,1.56c-0.39-1.58-0.79-3.16-1.18-4.74c-0.14-0.58-0.29-1.16-0.49-1.73c-0.48-1.35-1.27-2.58-1.62-3.97
		c-0.18-0.71-0.24-1.45-0.17-2.18c0.37-0.03,0.64,0.33,0.82,0.65c0.48,0.84,0.96,1.68,1.44,2.52"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M17.17,27.78c0.03-0.31-0.01-0.56-0.13-0.85c-0.12-0.29-0.59-0.29-0.59,0.08c0,1.75,0.28,3.48,0.88,5.13
			c0.3,0.82,0.71,1.6,0.95,2.44c0.21,0.73,0.39,2.1-0.64,2.29c0.12,0.07,0.25,0.14,0.37,0.21c-0.53-2.14-0.93-4.38-1.67-6.46
			c-0.73-2.05-1.95-3.79-1.78-6.06c-0.1,0.1-0.2,0.2-0.3,0.3c0.51,0.03,0.89,1.08,1.1,1.45c0.3,0.53,0.6,1.05,0.9,1.58
			c0.19,0.34,0.71,0.03,0.52-0.3c-0.46-0.81-0.91-1.61-1.38-2.42c-0.27-0.47-0.56-0.87-1.14-0.91c-0.17-0.01-0.29,0.15-0.3,0.3
			c-0.08,1.07,0.07,2.11,0.45,3.11c0.37,0.99,0.89,1.91,1.27,2.9c0.38,1.01,0.6,2.08,0.86,3.12c0.29,1.18,0.59,2.37,0.88,3.55
			c0.04,0.17,0.21,0.24,0.37,0.21c1.84-0.35,1.17-2.86,0.71-3.99c-0.87-2.1-1.46-4.15-1.46-6.45c-0.2,0.03-0.39,0.05-0.59,0.08
			c0.1,0.24,0.13,0.44,0.11,0.69C16.54,28.16,17.14,28.16,17.17,27.78L17.17,27.78z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M31.8,17.6c1.31,5.06,0.84,10.49-0.89,15.43c-1.07,3.06-2.08,6.09-1.89,9.33c0.01,0.17,0.03,0.36,0.13,0.5
		c0.25,0.35,0.84,0.23,1.11-0.1s0.3-0.78,0.36-1.2c0.3-2.15,0.86-4.09,1.7-6.11c1.85-4.42,2.4-9.27,2.37-14.05
		c-0.01-0.96-0.05-1.96-0.52-2.8s-1.5-1.47-2.43-1.17"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M31.51,17.68c1.1,4.4,0.92,8.98-0.29,13.34c-0.57,2.05-1.39,4.02-1.91,6.09c-0.23,0.9-0.41,1.82-0.51,2.74
			c-0.09,0.82-0.3,2.03-0.03,2.84c0.26,0.78,1.18,0.85,1.71,0.27c0.42-0.46,0.42-1.21,0.51-1.79c0.17-1.04,0.4-2.07,0.7-3.08
			c0.63-2.09,1.58-4.06,2.14-6.17c0.5-1.9,0.81-3.85,0.98-5.81c0.21-2.34,1.27-9.82-3.15-8.97c-0.38,0.07-0.22,0.65,0.16,0.58
			c4.32-0.83,2.16,10.86,1.69,12.96c-0.47,2.08-1.26,3.98-1.98,5.98c-0.36,0.99-0.65,1.99-0.87,3.02c-0.13,0.6-0.22,1.2-0.32,1.8
			c-0.02,0.21-0.06,0.42-0.1,0.63c-0.66,0.5-0.97,0.51-0.92,0.02c-0.17-0.38-0.01-1.19,0.02-1.6c0.05-0.65,0.14-1.3,0.26-1.93
			c0.2-1.04,0.48-2.07,0.8-3.08c0.63-2.03,1.4-3.99,1.84-6.08c0.84-3.94,0.84-8-0.14-11.91C31.99,17.14,31.41,17.3,31.51,17.68
			L31.51,17.68z"
          />
        </g>
      </g>
      <path
        style={{ fill: '#F2B477' }}
        d="M32.71,12.85l-0.59,12.28c-0.05,0.95-0.51,1.82-1.29,2.34l-4.08,2.24c-1.68,1.12-2.98,1.12-4.66,0l-4.08-2.24
	c-0.78-0.52-1.24-1.39-1.29-2.34l-0.59-12.29c-0.07-1.39,0.19-2.71,1.37-3.41l4.17-2.48c1.68-1,3.75-1,5.44-0.01l4.21,2.49
	C32.52,10.13,32.78,11.45,32.71,12.85z"
      />
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M14.95,17.85c0.07,2.19-0.92,4.42-0.3,6.54c0.32,1.09,1.04,2.04,1.86,2.84c-0.01-1.5-0.01-2.99-0.02-4.49
		c-0.01-1.24-0.01-2.5,0.21-3.72c0.12-0.66,0.25-1.47-0.27-1.9c-0.5-0.41-1.42-0.04-1.48,0.6"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M14.65,17.85c0.04,1.82-0.61,3.59-0.49,5.41c0.1,1.67,0.98,3.02,2.14,4.18c0.18,0.18,0.51,0.05,0.51-0.21
			c-0.01-1.37-0.01-2.73-0.02-4.1c-0.01-1.42,0-2.83,0.23-4.24c0.13-0.76,0.19-1.81-0.67-2.17c-0.69-0.28-1.57,0.17-1.7,0.9
			c-0.07,0.38,0.51,0.54,0.58,0.16c0.06-0.36,0.44-0.64,0.82-0.54c0.46,0.12,0.48,0.68,0.45,1.07c-0.07,0.92-0.27,1.81-0.3,2.74
			c-0.07,2.05,0,4.11,0.01,6.16c0.17-0.07,0.34-0.14,0.51-0.21c-1.2-1.19-2-2.55-1.97-4.28c0.02-1.64,0.54-3.24,0.5-4.89
			C15.25,17.46,14.65,17.46,14.65,17.85L14.65,17.85z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M32.29,10.98c0.31-0.07,0.63-0.14,0.95-0.13c0.32,0.01,0.65,0.12,0.86,0.36c0.18,0.21,0.25,0.49,0.3,0.75
		c0.09,0.54,0.1,1.09,0.04,1.63c-0.06,0.5-0.18,1.04,0.08,1.47c0.31,0.51,1.01,0.63,1.62,0.62c-0.2,0.26-0.42,0.53-0.73,0.65
		c-0.36,0.14-0.78,0.06-1.11-0.15s-0.57-0.51-0.79-0.83c-0.87-1.29-1.34-2.83-1.33-4.38"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M32.37,11.27c0.65-0.15,1.48-0.27,1.69,0.54c0.18,0.69,0.12,1.41,0.03,2.11c-0.08,0.6-0.04,1.23,0.45,1.64
			c0.44,0.36,1.04,0.44,1.59,0.43c-0.07-0.17-0.14-0.34-0.21-0.51c-0.17,0.21-0.34,0.45-0.59,0.57c-0.27,0.13-0.6,0.05-0.85-0.09
			c-0.51-0.3-0.84-0.89-1.12-1.4c-0.59-1.1-0.9-2.33-0.9-3.58c0-0.39-0.6-0.39-0.6,0c0,1.51,0.42,3.01,1.22,4.29
			c0.37,0.59,0.83,1.2,1.54,1.39c0.74,0.19,1.28-0.2,1.72-0.75c0.15-0.19,0.07-0.52-0.21-0.51c-0.51,0.01-1.25-0.05-1.44-0.63
			c-0.1-0.31-0.03-0.66,0.01-0.97c0.05-0.38,0.08-0.76,0.06-1.15c-0.03-0.6-0.09-1.35-0.6-1.76c-0.57-0.45-1.31-0.33-1.96-0.18
			C31.83,10.78,31.99,11.35,32.37,11.27L32.37,11.27z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#CC5050' }}
          d="M15.32,17.67c5.58-2.05,11.66-2.02,17.22,0.1c0.58,0.22,1.17,0.47,1.66,0.9c0.13-2.5-0.36-5.04-1.37-7.21
		c-0.21-0.45-0.45-0.89-0.74-1.27c-0.52-0.68-1.2-1.15-1.86-1.61c-0.63-0.44-1.27-0.88-1.9-1.32c-1.01-0.7-2.05-1.42-3.21-1.58
		c-1.36-0.19-2.71,0.4-3.99,1.01c-1.69,0.81-3.44,1.75-4.51,3.53c-0.3,0.51-0.54,1.08-0.75,1.66c-0.63,1.75-1.03,3.62-1.18,5.52"
        />
        <g>
          <path
            style={{ fill: '#AF4848' }}
            d="M15.38,17.89c2.97-1.07,6.1-1.6,9.26-1.49c1.62,0.06,3.22,0.27,4.8,0.65c1.53,0.37,3.36,0.79,4.61,1.79
			c0.15,0.12,0.38,0.05,0.38-0.16c0.11-2.84-0.38-6.33-2.18-8.65c-0.91-1.16-2.3-1.92-3.49-2.75c-1.2-0.83-2.46-1.79-3.98-1.86
			c-1.51-0.08-2.96,0.67-4.27,1.33c-1.13,0.56-2.24,1.21-3.13,2.13c-2.08,2.15-2.67,5.67-2.91,8.53c-0.02,0.29,0.43,0.29,0.45,0
			c0.23-2.68,0.78-6.05,2.68-8.1c0.81-0.87,1.83-1.5,2.88-2.04c1.31-0.67,2.78-1.47,4.3-1.39c1.48,0.07,2.74,1.1,3.91,1.91
			c1.17,0.81,2.56,1.56,3.37,2.76c1.57,2.29,2.03,5.43,1.92,8.14c0.13-0.05,0.26-0.11,0.38-0.16c-1.16-0.93-2.71-1.35-4.12-1.73
			c-1.6-0.43-3.25-0.7-4.9-0.81c-3.43-0.22-6.85,0.31-10.07,1.47C14.99,17.55,15.11,17.99,15.38,17.89L15.38,17.89z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#CC8F87' }}
          d="M21.81,26.58c1.03,0.42,2.2,0.37,3.31,0.3c0.59-0.03,1.18-0.07,1.78-0.1c-0.13-0.13-0.3-0.18-0.48-0.23
		c-1.49-0.43-3.11-0.46-4.62-0.06"
        />
        <g>
          <path
            style={{ fill: '#CC8F87' }}
            d="M21.76,26.76c0.78,0.31,1.62,0.37,2.45,0.35c0.9-0.02,1.79-0.09,2.69-0.14c0.15-0.01,0.26-0.21,0.13-0.32
			c-0.3-0.26-0.72-0.34-1.1-0.42c-0.46-0.1-0.92-0.17-1.39-0.19c-0.94-0.06-1.88,0.04-2.78,0.27c-0.23,0.06-0.13,0.42,0.1,0.36
			c0.82-0.21,1.65-0.3,2.5-0.27c0.42,0.02,0.84,0.06,1.25,0.14c0.36,0.07,0.88,0.12,1.17,0.37c0.04-0.11,0.09-0.21,0.13-0.32
			c-0.87,0.05-1.73,0.11-2.6,0.14c-0.83,0.02-1.66-0.03-2.44-0.34C21.64,26.31,21.54,26.67,21.76,26.76L21.76,26.76z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#C1867C' }}
          d="M21.82,26.45c0.44-0.35,0.93-0.64,1.45-0.87c0.15-0.07,0.3-0.13,0.46-0.12s0.33,0.09,0.39,0.24
		c0.09-0.24,0.38-0.37,0.64-0.36c0.26,0.01,0.51,0.14,0.74,0.26c0.49,0.25,0.99,0.51,1.37,0.9c-0.87-0.16-1.73-0.32-2.61-0.35
		c-0.88-0.03-1.78,0.06-2.59,0.4"
        />
        <g>
          <path
            style={{ fill: '#C1867C' }}
            d="M21.91,26.61c0.31-0.24,0.64-0.46,0.98-0.64c0.23-0.12,0.88-0.55,1.06-0.18c0.06,0.12,0.27,0.13,0.32,0
			c0.24-0.54,0.94-0.14,1.29,0.04c0.42,0.22,0.84,0.45,1.18,0.79c0.06-0.1,0.12-0.21,0.18-0.31c-1.75-0.32-3.6-0.64-5.3,0.05
			c-0.22,0.09-0.12,0.45,0.1,0.36c1.64-0.66,3.42-0.36,5.1-0.05c0.17,0.03,0.33-0.17,0.18-0.31c-0.46-0.45-1.06-0.78-1.65-1.04
			c-0.47-0.21-1.15-0.28-1.41,0.29c0.11,0,0.22,0,0.32,0c-0.21-0.42-0.71-0.35-1.07-0.2c-0.53,0.23-1.03,0.53-1.49,0.89
			C21.54,26.44,21.72,26.76,21.91,26.61L21.91,26.61z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#6D5A4D' }}
          d="M28.27,26.51c-0.01,0.23-0.24,0.36-0.45,0.26c-0.2-0.11-0.37-0.24-0.53-0.4c-0.1,0.13-0.34,0.21-0.47,0.05
		c-0.18-0.23-0.36-0.47-0.53-0.71c-0.03,0.04-0.06,0.08-0.1,0.12c-0.14,0.12-0.32,0.17-0.49,0.09c-0.18-0.08-0.28-0.29-0.39-0.45
		c-0.03-0.04-0.06-0.08-0.09-0.13c-0.18,0.18-0.39,0.3-0.61,0.08c-0.06-0.06-0.12-0.14-0.17-0.23c-0.05,0.09-0.11,0.17-0.17,0.23
		c-0.22,0.22-0.44,0.1-0.61-0.08c-0.03,0.05-0.07,0.11-0.11,0.16c-0.11,0.15-0.2,0.34-0.37,0.42c-0.17,0.08-0.37,0.03-0.5-0.1
		c-0.03-0.03-0.07-0.08-0.09-0.12c-0.17,0.25-0.34,0.49-0.53,0.72c-0.13,0.16-0.37,0.08-0.47-0.05c-0.16,0.16-0.33,0.29-0.53,0.4
		c-0.21,0.1-0.44-0.03-0.45-0.26c-0.02-0.46,0.26-1.9,0.37-1.91c0.46-0.47,1.24-0.77,1.67-0.99c0.07-0.03,0.19-0.11,0.26-0.15
		c0.2-0.12,0.54-0.3,0.82-0.45c0.22-0.12,0.43-0.26,0.69-0.22c0.27,0.04,0.55,0.2,0.8,0.32s0.51,0.25,0.75,0.4
		c0.03,0.02,0.06,0.04,0.08,0.05c0.48,0.23,1.35,0.52,1.85,1.04C28.01,24.61,28.29,26.05,28.27,26.51z"
        />
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M34.72,25.18c0.43,2.91,0.64,5.9,0.63,8.88c0,0.94-0.03,1.9-0.3,2.75c-0.13,0.4-0.36,0.8-0.66,0.79
		c-0.23-0.01-0.43-0.29-0.52-0.62s-0.09-0.69-0.09-1.05C33.81,32.23,34.72,28.88,34.72,25.18"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M34.37,25.28c0.3,2.07,0.49,4.15,0.57,6.25c0.04,0.99,0.06,1.98,0.04,2.97c-0.01,0.51-0.03,1.01-0.12,1.51
			c-0.04,0.24-0.26,1.57-0.66,0.87c-0.2-0.35-0.08-1.04-0.07-1.42c0.01-0.5,0.05-1.01,0.09-1.51c0.08-0.95,0.2-1.89,0.32-2.83
			c0.26-1.97,0.53-3.94,0.54-5.94c0-0.46-0.72-0.46-0.72,0c-0.01,2.45-0.42,4.86-0.71,7.29c-0.14,1.21-0.27,2.45-0.25,3.67
			c0.01,0.62,0.15,1.85,1.02,1.81c0.82-0.04,1.05-1.24,1.15-1.86c0.19-1.15,0.14-2.33,0.12-3.48c-0.05-2.52-0.27-5.03-0.63-7.52
			C35,24.63,34.31,24.82,34.37,25.28L34.37,25.28z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#AD7953' }}
          d="M34.79,24.14c1.7,1.75,2.47,4.07,2.59,6.48s-0.49,4.81-1.43,7.05c-0.44,1.05-0.98,2.15-0.82,3.28
		c-0.44-0.29-0.6-0.87-0.55-1.39c0.06-0.52-0.38-2.36-0.2-2.85c0.84-2.27,1.32-3.41,0.98-5.8s-0.84-4.79-0.6-7.18"
        />
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M34.58,24.35c2.02,2.15,2.71,5.1,2.46,7.99c-0.13,1.55-0.54,3.06-1.09,4.51c-0.51,1.34-1.25,2.61-1.13,4.09
			c0.17-0.07,0.34-0.14,0.51-0.21c-0.56-0.46-0.42-1.1-0.49-1.73c-0.06-0.56-0.17-1.11-0.2-1.67c-0.03-0.63,0.26-1.18,0.47-1.76
			c0.23-0.65,0.44-1.3,0.55-1.98c0.23-1.37,0-2.71-0.21-4.06c-0.3-1.93-0.56-3.85-0.39-5.8c0.03-0.38-0.57-0.38-0.6,0
			c-0.16,1.89,0.08,3.77,0.36,5.64c0.27,1.79,0.52,3.44-0.01,5.21c-0.21,0.71-0.57,1.39-0.74,2.11c-0.11,0.47-0.01,0.98,0.05,1.44
			c0.13,1-0.08,2.34,0.78,3.04c0.18,0.15,0.54,0.07,0.51-0.21c-0.14-1.74,0.96-3.36,1.47-4.98c0.47-1.47,0.77-3.01,0.79-4.56
			c0.04-2.75-0.78-5.45-2.69-7.48C34.74,23.65,34.31,24.07,34.58,24.35L34.58,24.35z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#AF4848' }}
            d="M34.4,16.63c-0.07-0.57-0.41-1.08-0.73-1.55c-0.31-0.46-0.66-0.9-1.05-1.31c-0.78-0.82-1.69-1.51-2.69-2.04
			c-0.26-0.14-0.48,0.25-0.23,0.39c0.92,0.49,1.76,1.11,2.49,1.86c0.35,0.36,0.68,0.76,0.98,1.17c0.15,0.22,0.29,0.44,0.43,0.66
			c0.15,0.25,0.31,0.52,0.35,0.81C33.99,16.91,34.44,16.92,34.4,16.63L34.4,16.63z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#AF4848' }}
            d="M34.19,15.34c0.01-1.48-1.22-2.44-1.98-3.56c-0.16-0.24-0.55-0.01-0.39,0.23c0.7,1.03,1.93,1.98,1.92,3.34
			C33.74,15.63,34.19,15.63,34.19,15.34L34.19,15.34z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#AF4848' }}
            d="M14.98,16.88c0.04-0.37,0.22-0.71,0.41-1.03c0.18-0.3,0.35-0.61,0.55-0.89c0.3-0.44,0.66-0.8,1.08-1.12
			c0.43-0.33,0.9-0.63,1.38-0.89c0.42-0.23,0.87-0.45,1.34-0.55c0.28-0.06,0.16-0.49-0.12-0.43c-0.51,0.11-0.99,0.35-1.45,0.59
			c-0.53,0.29-1.05,0.62-1.52,1c-0.47,0.37-0.85,0.78-1.17,1.27c-0.4,0.62-0.87,1.29-0.95,2.04C14.49,17.17,14.94,17.17,14.98,16.88
			L14.98,16.88z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#AF4848' }}
            d="M15.35,15.27c0.05-0.44,0.29-0.83,0.51-1.2c0.24-0.4,0.48-0.81,0.78-1.17c0.2-0.24,0.42-0.45,0.7-0.61
			c0.25-0.14,0.49-0.29,0.71-0.49c0.22-0.19-0.1-0.51-0.32-0.32c-0.22,0.2-0.47,0.32-0.71,0.48c-0.32,0.2-0.58,0.48-0.81,0.77
			c-0.3,0.38-0.55,0.8-0.79,1.21c-0.24,0.41-0.46,0.83-0.51,1.31C14.87,15.56,15.32,15.55,15.35,15.27L15.35,15.27z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#6D5A4D' }}
          d="M21.27,29.19c0.09,0.57,0.48,1.09,1,1.35c0.02-0.08,0.04-0.17,0.06-0.25c0.25,0.37,0.56,0.69,0.93,0.94
		c0.07-0.17,0.26-0.29,0.45-0.28c0.19,0,0.37,0.13,0.43,0.31c0.17-0.1,0.34-0.2,0.51-0.31c0.07,0.14,0.14,0.28,0.21,0.42
		c0.23-0.17,0.45-0.35,0.64-0.56c-0.03,0.12,0.11,0.22,0.23,0.21c0.12-0.01,0.22-0.09,0.31-0.17c0.56-0.5,1.02-1.12,1.22-1.83
		c-1.65,0.43-3.4,0.29-5.11,0.14c-0.33-0.03-0.66-0.06-0.98-0.13"
        />
        <g>
          <path
            style={{ fill: '#6D5A4D' }}
            d="M20.99,29.27c0.13,0.66,0.55,1.22,1.14,1.53c0.17,0.09,0.39,0.01,0.44-0.18c0.02-0.08,0.04-0.17,0.06-0.25
			c-0.18,0.02-0.37,0.05-0.55,0.07c0.29,0.41,0.63,0.76,1.04,1.05c0.13,0.09,0.34,0.03,0.41-0.11c0.1-0.18,0.27-0.16,0.36,0.02
			c0.07,0.15,0.28,0.19,0.41,0.11c0.17-0.1,0.34-0.2,0.51-0.31c-0.14-0.04-0.27-0.07-0.41-0.11c0.07,0.14,0.14,0.28,0.21,0.42
			c0.07,0.13,0.28,0.2,0.41,0.11c0.25-0.19,0.49-0.38,0.7-0.6c-0.17-0.07-0.34-0.14-0.51-0.21c0.01,0.29,0.23,0.52,0.53,0.51
			c0.32-0.01,0.57-0.29,0.77-0.49c0.48-0.49,0.85-1.07,1.05-1.73c0.07-0.22-0.15-0.42-0.37-0.37c-0.97,0.25-1.97,0.3-2.97,0.27
			c-0.97-0.03-2.01-0.05-2.96-0.26c-0.38-0.08-0.54,0.5-0.16,0.58c1.01,0.22,2.09,0.25,3.12,0.28c1.05,0.03,2.11-0.03,3.13-0.29
			c-0.12-0.12-0.25-0.25-0.37-0.37c-0.11,0.36-0.28,0.7-0.5,1c-0.11,0.15-0.23,0.29-0.36,0.42c-0.07,0.07-0.14,0.14-0.21,0.2
			c-0.02,0.02-0.05,0.04-0.07,0.07c-0.1,0.04-0.11,0.09-0.03,0.17c0-0.26-0.33-0.4-0.51-0.21c-0.18,0.18-0.37,0.36-0.58,0.51
			c0.14,0.04,0.27,0.07,0.41,0.11c-0.07-0.14-0.14-0.28-0.21-0.42c-0.07-0.14-0.28-0.19-0.41-0.11C24.34,30.8,24.17,30.9,24,31
			c0.14,0.04,0.27,0.07,0.41,0.11c-0.28-0.59-1.09-0.58-1.4-0.02c0.14-0.04,0.27-0.07,0.41-0.11c-0.32-0.23-0.6-0.51-0.82-0.83
			c-0.14-0.2-0.48-0.19-0.55,0.07c-0.02,0.08-0.04,0.17-0.06,0.25c0.15-0.06,0.29-0.12,0.44-0.18c-0.46-0.25-0.76-0.66-0.86-1.17
			C21.49,28.73,20.91,28.89,20.99,29.27L20.99,29.27z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#6D5A4D' }}
            d="M23.62,29.24c0.17-0.21,0.3-0.43,0.4-0.68c0.04-0.1,0.08-0.21,0.1-0.32c0.01-0.06,0.03-0.12,0.03-0.18
			c0.01-0.04,0.01-0.09,0.02-0.13c0.01-0.08-0.01,0.04-0.03,0.06c-0.04,0.03-0.09,0.05-0.13,0.08c0.06-0.02-0.06-0.01,0.04,0
			c0.03,0,0.07,0,0.1,0c0.07,0,0.14,0,0.22,0c0.14,0,0.29,0,0.43,0c-0.1-0.1-0.2-0.2-0.3-0.3c0.07,0.62,0.3,1.18,0.69,1.68
			c0.12-0.16,0.24-0.31,0.36-0.47c-0.23-0.12-0.39-0.28-0.58-0.48c-0.21-0.22-0.43-0.43-0.64-0.65c-0.09-0.09-0.25-0.11-0.36-0.05
			c-0.12,0.07-0.16,0.21-0.14,0.34c0,0.02,0.01,0.04,0.01,0.06c-0.01-0.03,0-0.01,0,0.01c0,0.04,0,0.08,0,0.12c0,0.02,0,0.04,0,0.06
			c0,0.02-0.01,0.04,0,0.01c-0.01,0.05-0.02,0.09-0.03,0.13c-0.03,0.09-0.03,0.1-0.08,0.18c-0.05,0.09-0.07,0.11-0.13,0.17
			c-0.1,0.11-0.12,0.28-0.02,0.39c0.09,0.11,0.26,0.16,0.39,0.08c0.13-0.09,0.28-0.19,0.41-0.23c0.11-0.03,0.19-0.03,0.29,0.05
			c0.13,0.1,0.34,0.02,0.41-0.11c0.09-0.15,0.02-0.31-0.11-0.41c-0.41-0.32-0.94-0.07-1.31,0.18c0.12,0.16,0.24,0.31,0.36,0.47
			c0.34-0.36,0.48-0.85,0.38-1.34c-0.17,0.1-0.33,0.19-0.5,0.29c0.22,0.22,0.45,0.45,0.67,0.67c0.2,0.21,0.42,0.41,0.68,0.55
			c0.13,0.07,0.29,0.05,0.39-0.08c0.1-0.13,0.07-0.27-0.02-0.39c0.02,0.02-0.03-0.05-0.03-0.05c-0.02-0.03-0.04-0.05-0.06-0.08
			c-0.03-0.05-0.06-0.09-0.09-0.14c-0.03-0.06-0.07-0.12-0.09-0.18c-0.01-0.02-0.02-0.05-0.04-0.08c-0.01-0.02-0.01-0.03-0.02-0.05
			c0.01,0.02,0.01,0.01,0-0.01c-0.05-0.11-0.08-0.23-0.12-0.35c-0.02-0.06-0.03-0.12-0.04-0.18c-0.01-0.03-0.01-0.07-0.02-0.1
			c-0.01-0.06,0,0.01-0.01-0.05c-0.02-0.16-0.12-0.3-0.3-0.3c-0.22,0-0.44,0-0.67,0c-0.13,0-0.26,0-0.38,0.08
			c-0.12,0.09-0.15,0.21-0.17,0.35c-0.04,0.3-0.19,0.67-0.38,0.91c-0.1,0.13-0.12,0.3,0,0.42C23.3,29.34,23.52,29.36,23.62,29.24
			L23.62,29.24z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#6D5A4D' }}
            d="M23.06,31.25C23,31.48,22.89,31.76,22.92,32c0.03,0.25,0.23,0.42,0.48,0.42c0.55-0.01,0.61-0.67,0.28-0.99
			c-0.18-0.18-0.52-0.05-0.51,0.21c0.01,0.35-0.19,0.52-0.38,0.79c-0.19,0.25-0.27,0.62-0.05,0.88c0.19,0.22,0.53,0.29,0.76,0.09
			c0.22-0.19,0.2-0.5,0.11-0.75c-0.08-0.23-0.41-0.31-0.55-0.07c-0.14,0.25-0.3,0.5-0.43,0.75c-0.12,0.23-0.15,0.51,0.04,0.71
			c0.16,0.17,0.42,0.19,0.6,0.05c0.17-0.13,0.21-0.36,0.19-0.57c-0.03-0.35-0.46-0.39-0.59-0.08c-0.19,0.47-0.23,0.97-0.14,1.47
			c0.04,0.25,0.44,0.3,0.55,0.07c0.14-0.29,0.17-0.57,0.11-0.89c-0.07-0.33-0.62-0.26-0.59,0.08c0.04,0.53,0.06,1.06,0.06,1.6
			c0,0.35,0.48,0.39,0.59,0.08c0.08-0.23,0.15-0.47,0.19-0.71c0.07-0.38-0.51-0.54-0.58-0.16c-0.04,0.24-0.11,0.48-0.19,0.71
			c0.2,0.03,0.39,0.05,0.59,0.08c0-0.53-0.01-1.07-0.06-1.6c-0.2,0.03-0.39,0.05-0.59,0.08c0.03,0.15,0.02,0.29-0.05,0.43
			c0.18,0.02,0.37,0.05,0.55,0.07c-0.07-0.4-0.01-0.78,0.14-1.15c-0.2-0.03-0.39-0.05-0.59-0.08c0.01,0.11-0.04,0.37,0.28,0.11
			c0.05-0.04,0.09-0.16,0.12-0.22c0.1-0.18,0.2-0.36,0.31-0.54c-0.18-0.02-0.37-0.05-0.55-0.07c0.05,0.13,0.06,0.26,0.19,0.08
			c0.09-0.13,0.18-0.25,0.28-0.38c0.19-0.25,0.28-0.55,0.27-0.86c-0.17,0.07-0.34,0.14-0.51,0.21c0.06,0.06,0.03,0.06,0.15,0.07
			c0.14,0.01,0.1,0,0.13-0.13c0.03-0.13,0.06-0.26,0.09-0.39C23.72,31.03,23.14,30.87,23.06,31.25L23.06,31.25z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#6D5A4D' }}
            d="M25.16,31.41c0,0.32-0.13,1.26,0.47,1.11c0.51-0.12,0.45-0.85,0.28-1.21c-0.17,0.1-0.35,0.2-0.52,0.3
			c0.23,0.47,0.15,1-0.15,1.42c-0.13,0.17,0.04,0.48,0.26,0.45c0.5-0.06,0.88-0.64,0.55-1.1c-0.16-0.23-0.56-0.16-0.56,0.15
			c0,0.56,0.08,1.12,0.22,1.66c0.06,0.23,0.44,0.32,0.55,0.07c0.18-0.42,0.24-0.98-0.31-1.14c-0.26-0.08-0.45,0.21-0.34,0.44
			c0.15,0.29,0.19,0.62,0.1,0.94c-0.07,0.26-0.29,0.6,0.04,0.79c0.28,0.16,0.56-0.13,0.64-0.38c0.09-0.27,0.03-0.54-0.16-0.75
			c-0.19-0.21-0.62,0.01-0.5,0.29c0.2,0.47,0.15,0.97-0.15,1.39c-0.16,0.23,0.1,0.49,0.34,0.44c0.48-0.1,0.52-0.6,0.43-0.99
			c-0.09-0.37-0.67-0.22-0.58,0.16c0.02,0.07,0.08,0.24-0.01,0.26c0.11,0.15,0.23,0.29,0.34,0.44c0.37-0.54,0.46-1.25,0.21-1.85
			c-0.17,0.1-0.33,0.19-0.5,0.29c0.06,0.07,0.03,0.15-0.04,0.2c0.1,0,0.2,0,0.3,0c0.04,0.22,0.08,0.27,0.11,0.17
			c0.01-0.02,0.02-0.05,0.03-0.07c0.03-0.07,0.06-0.14,0.08-0.21c0.04-0.16,0.07-0.33,0.07-0.49c0-0.32-0.08-0.63-0.23-0.91
			c-0.11,0.15-0.23,0.29-0.34,0.44c0.05,0.02-0.04,0.22-0.05,0.26c0.18,0.02,0.37,0.05,0.55,0.07c-0.13-0.49-0.2-0.99-0.2-1.5
			c-0.19,0.05-0.37,0.1-0.56,0.15c0.04,0.06,0.04,0.19-0.04,0.19c0.09,0.15,0.17,0.3,0.26,0.45c0.44-0.59,0.48-1.37,0.15-2.02
			c-0.17-0.35-0.68-0.04-0.52,0.3c0.05,0.1,0.03,0.17,0.04,0.27c-0.01,0.02-0.01,0.05-0.02,0.07c0.25,0.21,0.36,0.22,0.33,0.04
			c0.03-0.19,0-0.4,0-0.59C25.76,31.02,25.16,31.02,25.16,31.41L25.16,31.41z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#6D5A4D' }}
            d="M25.66,36.09c0.38,0.92-0.03,1.88-0.42,2.72c-0.05,0.1,0.05,0.21,0.15,0.15c0.24-0.12,0.38-0.36,0.47-0.61
			c0.12-0.33,0.19-0.68,0.24-1.02c-0.07,0.01-0.14,0.02-0.21,0.03c0.18,0.26,0.26,0.58,0.21,0.9c-0.02,0.14,0.17,0.2,0.22,0.06
			c0.26-0.76-0.09-1.52-0.35-2.22c-0.07,0.02-0.14,0.04-0.22,0.06c0.17,0.44,0.27,0.9,0.29,1.37c0,0.14,0.23,0.14,0.22,0
			c-0.01-0.49-0.11-0.98-0.29-1.43c-0.05-0.13-0.27-0.08-0.22,0.06c0.25,0.67,0.6,1.38,0.35,2.1c0.07,0.02,0.14,0.04,0.22,0.06
			c0.06-0.38-0.01-0.75-0.23-1.07c-0.05-0.07-0.19-0.08-0.21,0.03c-0.04,0.31-0.11,0.61-0.2,0.91c-0.07,0.23-0.18,0.47-0.41,0.58
			c0.05,0.05,0.1,0.1,0.15,0.15c0.41-0.89,0.84-1.92,0.44-2.89C25.82,35.9,25.6,35.96,25.66,36.09L25.66,36.09z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#6D5A4D' }}
            d="M23.17,35.95c-0.33,0.45-0.7,1.19-0.28,1.7c0.17,0.21,0.44,0.31,0.71,0.28c0.19-0.02,0.66-0.2,0.5-0.47
			c-0.03-0.05-0.1-0.08-0.15-0.04c-0.17,0.12-0.39,0.27-0.61,0.22c-0.17-0.04-0.28-0.21-0.32-0.37c-0.05-0.21,0.03-0.44,0.11-0.63
			c0.09-0.22,0.18-0.43,0.27-0.64c0.06-0.13-0.11-0.23-0.19-0.11c-0.07,0.1-0.09,0.22-0.1,0.34c-0.02,0.14-0.02,0.29-0.02,0.43
			c0.01,0.28,0.05,0.57,0.12,0.84c0.12,0.45,0.43,0.94,0.96,0.85c-0.02-0.07-0.04-0.14-0.06-0.22c-0.37,0.06-0.72-0.18-0.81-0.54
			c-0.05-0.21-0.05-0.45-0.05-0.66c0-0.23,0.01-0.46,0.07-0.68c0.04-0.14-0.18-0.2-0.22-0.06c-0.07,0.27-0.08,0.55-0.07,0.83
			c0.01,0.26,0.01,0.54,0.11,0.79c0.17,0.4,0.61,0.62,1.03,0.55c0.14-0.02,0.08-0.24-0.06-0.22c-0.45,0.08-0.64-0.48-0.72-0.82
			c-0.05-0.21-0.08-0.43-0.08-0.65c0-0.11,0-0.23,0.01-0.34c0.01-0.11,0.01-0.22,0.08-0.31c-0.06-0.04-0.13-0.08-0.19-0.11
			c-0.11,0.27-0.24,0.54-0.34,0.82c-0.08,0.24-0.12,0.51-0.02,0.76c0.08,0.2,0.24,0.37,0.45,0.41c0.28,0.06,0.54-0.1,0.76-0.25
			c-0.05-0.01-0.1-0.03-0.15-0.04c-0.01-0.02,0-0.01-0.03,0c-0.02,0.01-0.04,0.03-0.07,0.04c-0.05,0.03-0.1,0.05-0.16,0.06
			c-0.1,0.03-0.2,0.03-0.3,0c-0.18-0.05-0.34-0.18-0.4-0.36c-0.08-0.22-0.01-0.46,0.07-0.67c0.08-0.21,0.2-0.41,0.33-0.59
			C23.45,35.94,23.25,35.83,23.17,35.95L23.17,35.95z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#9EBC73' }}
            d="M22.79,36c-0.02,0.1-0.05,0.21-0.09,0.3c-0.01,0.02-0.02,0.05-0.03,0.07c-0.02,0.04,0.02-0.04,0,0
			c-0.01,0.01-0.01,0.03-0.02,0.04c-0.02,0.05-0.05,0.1-0.07,0.14c-0.03,0.06-0.03,0.13,0,0.19c0.03,0.05,0.1,0.1,0.16,0.09
			c0.17-0.02,0.33-0.03,0.5-0.05c0.09-0.01,0.17-0.04,0.25-0.1c0.08-0.07,0.1-0.18,0.11-0.28c0.01-0.15-0.01-0.31-0.13-0.41
			c-0.15-0.13-0.37-0.11-0.52,0.03c-0.15,0.14-0.16,0.37-0.09,0.55c0.03,0.07,0.09,0.14,0.18,0.14c0.13-0.01,0.27-0.08,0.33-0.2
			c0.02-0.05,0.03-0.09,0.02-0.14c-0.01-0.04-0.05-0.09-0.09-0.11c-0.08-0.04-0.21-0.03-0.26,0.07c0,0.01-0.01,0.01-0.01,0.02
			c-0.01,0.02,0.01-0.02,0.01-0.01c0,0-0.05,0.05-0.02,0.02c0.03-0.03-0.04,0.02,0,0c0.03-0.01,0.01,0,0,0c-0.01,0-0.02,0-0.02,0.01
			c0.02,0,0.03,0,0.05-0.01c-0.01,0-0.01,0-0.02,0c0.06,0.05,0.12,0.09,0.18,0.14c-0.01-0.04-0.02-0.08-0.03-0.12
			c0,0.02,0,0.03,0.01,0.05c0-0.03,0-0.07,0-0.1c0,0.02,0,0.03-0.01,0.05c0-0.01,0-0.03,0.01-0.04c0-0.01,0-0.01,0.01-0.02
			c0.01-0.02,0-0.01-0.01,0.01c0-0.01,0.01-0.02,0.01-0.02c0.01-0.03-0.03,0.04,0,0c0.03-0.03-0.03,0.02,0,0
			c0.01,0,0.02-0.01,0.02-0.01c0.03-0.02-0.05,0.02,0,0c0.01,0,0.02-0.01,0.03-0.01c-0.02,0-0.03,0-0.05,0.01c0.02,0,0.03,0,0.05,0
			c-0.02,0-0.03,0-0.05-0.01c0.01,0,0.02,0,0.02,0.01c0.03,0.01-0.04-0.02-0.01-0.01c0.03,0.02-0.03-0.03-0.01-0.01
			c0.03,0.03-0.01-0.02,0-0.01c0,0.01,0.01,0.02,0.01,0.02c0.01,0.01-0.02-0.05-0.01-0.01c0.01,0.02,0.01,0.04,0.01,0.06
			c0-0.02,0-0.03-0.01-0.05c0.01,0.06,0.01,0.12,0,0.18c0-0.02,0-0.03,0.01-0.05c0,0.01,0,0.02-0.01,0.03c0,0.01,0,0.01,0,0
			c0.01-0.02,0.01-0.02,0,0c0.02-0.02,0.03-0.03,0.02-0.02c0,0-0.01,0.01-0.01,0.01c0.03-0.02,0.03-0.02,0.02-0.02
			c0,0-0.01,0-0.01,0.01c-0.03,0.02,0.04-0.01,0.01,0c-0.01,0-0.02,0.01-0.03,0.01c-0.02,0-0.04,0.01-0.06,0.01
			c0.02,0,0.03,0,0.05-0.01c-0.16,0.02-0.31,0.03-0.47,0.05c0.05,0.09,0.11,0.19,0.16,0.28c0.11-0.2,0.19-0.42,0.24-0.65
			c0.02-0.1-0.03-0.21-0.13-0.23C22.92,35.85,22.81,35.9,22.79,36L22.79,36z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#EAD5A0' }}
            d="M22.66,35.52c-0.09,0.11-0.11,0.24-0.06,0.37c0.05,0.12,0.15,0.2,0.27,0.24c0.12,0.04,0.25,0.02,0.37,0
			c0.03,0,0.05-0.01,0.08-0.01c0.05-0.01-0.04,0,0,0c0.01,0,0.03,0,0.04,0c0.01,0,0.07-0.01,0.08,0c0-0.01-0.04-0.01,0,0
			c0.02,0,0.03,0.01,0.04,0.01c0.06,0.02,0.12,0,0.16-0.03c0.05-0.04,0.07-0.09,0.07-0.15c0.01-0.17-0.01-0.34-0.05-0.5
			c-0.02-0.06-0.07-0.12-0.13-0.13c-0.13-0.02-0.26-0.04-0.39-0.01c-0.12,0.03-0.23,0.11-0.3,0.21c-0.08,0.13-0.09,0.38,0.1,0.43
			c0.13,0.04,0.28,0.01,0.4-0.05c0.09-0.05,0.12-0.17,0.07-0.26c-0.06-0.09-0.16-0.12-0.26-0.07c-0.01,0-0.02,0.01-0.02,0.01
			c0.03-0.02,0.02-0.01,0,0c-0.01,0-0.02,0-0.02,0.01c0,0-0.01,0-0.01,0c-0.01,0-0.01,0,0.02,0c-0.02,0-0.03,0-0.05,0
			c-0.01,0-0.04,0-0.01,0c0.03,0-0.01,0-0.01,0c0.04,0.04,0.09,0.09,0.13,0.13c0-0.01-0.01-0.05-0.01-0.01c0,0.04,0-0.01,0-0.01
			c0,0.01,0,0.02,0,0.03c0-0.01,0-0.01,0-0.02c0-0.01,0-0.01,0,0c-0.01,0.02-0.01,0.02,0,0c0-0.01,0.01-0.02,0.02-0.03
			c-0.02,0.02-0.02,0.03-0.01,0.01c0,0,0.01-0.01,0.01-0.01c0,0,0.01-0.01,0.01-0.01c0.01-0.01,0.01-0.01-0.01,0.01
			c0.01,0,0.02-0.01,0.03-0.02c0.01-0.01,0.01-0.01,0,0c-0.02,0.01-0.02,0.01,0,0c0.01,0,0.03-0.01,0.04-0.01
			c0.04-0.01-0.04,0,0.01,0c0.02,0,0.03,0,0.05,0c0.03,0,0.05,0,0.08,0.01c0.04,0-0.03-0.01,0,0c0.02,0,0.04,0.01,0.05,0.01
			c-0.04-0.04-0.09-0.09-0.13-0.13c0.01,0.04,0.02,0.07,0.03,0.11c0,0.02,0.01,0.04,0.01,0.06c0-0.05,0,0,0,0.01
			c0.01,0.07,0.01,0.15,0,0.22c0.08-0.06,0.16-0.12,0.24-0.18c-0.1-0.04-0.21-0.03-0.31-0.02c-0.05,0.01-0.1,0.02-0.14,0.02
			c-0.01,0-0.02,0-0.03,0.01c-0.02,0,0.04,0,0,0c-0.02,0-0.04,0-0.06,0c-0.01,0-0.02,0-0.03,0c0,0-0.05,0-0.01,0
			c0.03,0-0.01,0-0.01,0c-0.01,0-0.02-0.01-0.03-0.01c-0.02-0.01,0.03,0.02,0.01,0c-0.01,0-0.03-0.02,0,0
			c0.03,0.02-0.01-0.01-0.02-0.02c0.03,0.02,0.02,0.03,0.01,0.01c0,0-0.01-0.02-0.01-0.02c0,0,0.01,0.05,0.01,0.01
			c0,0-0.01-0.02-0.01-0.02c0,0,0,0.05,0,0.02c0-0.03-0.01,0.04,0,0.02c0.01-0.03-0.01,0.01-0.01,0.02c0,0,0-0.01,0-0.01
			c0.01-0.02,0.01-0.01-0.01,0.02c0.03-0.04,0.05-0.08,0.05-0.13c0-0.05-0.02-0.1-0.05-0.13C22.86,35.45,22.73,35.44,22.66,35.52
			L22.66,35.52z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#EAD5A0' }}
            d="M25.49,36.22c-0.06,0.05-0.09,0.14-0.09,0.22c0,0.09,0.03,0.16,0.09,0.23c0.05,0.06,0.12,0.1,0.19,0.11
			c0.08,0.02,0.15,0.01,0.23,0c0.02-0.01,0.05-0.01,0.07-0.02c0.04-0.01,0.07-0.03,0.1-0.05c0.06-0.04,0.12-0.09,0.15-0.16
			c0.04-0.08,0.05-0.17,0.03-0.25c-0.02-0.09-0.09-0.18-0.18-0.21c-0.05-0.02-0.12,0-0.17,0.01c-0.03,0-0.06,0.01-0.09,0.02
			c-0.07,0.02-0.14,0.05-0.2,0.1c-0.04,0.03-0.07,0.06-0.09,0.11c-0.01,0.04-0.01,0.1,0.02,0.14c0.03,0.04,0.06,0.08,0.11,0.09
			c0.05,0.01,0.1,0.01,0.14-0.02c0.03-0.02,0.07-0.04,0.1-0.06c-0.01,0.01-0.03,0.01-0.04,0.02c0.05-0.02,0.09-0.03,0.14-0.04
			c-0.02,0-0.03,0-0.05,0.01c0.02,0,0.05-0.01,0.07-0.01c-0.03-0.01-0.06-0.02-0.09-0.03c0,0,0,0,0,0
			c-0.01-0.01-0.03-0.02-0.04-0.03c0.01,0.01,0.01,0.01,0.02,0.02c-0.01-0.01-0.02-0.03-0.03-0.04c0.01,0.01,0.01,0.02,0.02,0.03
			c-0.01-0.01-0.01-0.03-0.02-0.04c0.01,0.01,0.01,0.03,0.01,0.04c0-0.02,0-0.03-0.01-0.05c0,0.02,0,0.03,0,0.05
			c0-0.02,0-0.03,0.01-0.05c0,0.02-0.01,0.03-0.01,0.05c0.01-0.01,0.01-0.03,0.02-0.04c-0.01,0.02-0.02,0.03-0.03,0.04
			c0.01-0.01,0.02-0.03,0.03-0.04c-0.01,0.02-0.03,0.03-0.04,0.04c0.01-0.01,0.03-0.02,0.04-0.03c-0.02,0.02-0.05,0.03-0.07,0.04
			c0.01-0.01,0.03-0.01,0.04-0.02c-0.03,0.01-0.06,0.02-0.1,0.03c0.02,0,0.03,0,0.05-0.01c-0.03,0-0.06,0-0.08,0
			c0.02,0,0.03,0,0.05,0.01c-0.02,0-0.04-0.01-0.06-0.02c0.01,0.01,0.03,0.01,0.04,0.02c-0.01-0.01-0.03-0.01-0.04-0.02
			c0.01,0.01,0.03,0.02,0.04,0.03c-0.01-0.01-0.02-0.02-0.03-0.03c0.01,0.01,0.02,0.03,0.03,0.04c-0.01-0.01-0.01-0.02-0.02-0.03
			c0.01,0.01,0.01,0.03,0.02,0.04c-0.01-0.01-0.01-0.03-0.01-0.04c0,0.02,0,0.03,0.01,0.05c0-0.01,0-0.02,0-0.04
			c0,0.02,0,0.03-0.01,0.05c0-0.01,0-0.02,0.01-0.03c-0.01,0.01-0.01,0.03-0.02,0.04c0-0.01,0.01-0.02,0.01-0.02
			c-0.01,0.01-0.02,0.03-0.03,0.04c0-0.01,0.01-0.01,0.02-0.02c0.03-0.03,0.05-0.09,0.05-0.13c0-0.05-0.02-0.1-0.05-0.13
			c-0.04-0.03-0.08-0.06-0.13-0.05C25.57,36.17,25.53,36.19,25.49,36.22L25.49,36.22z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#EAD5A0' }}
            d="M27.39,6.4c-0.2,0.16-0.3,0.4-0.38,0.63c-0.09,0.28-0.17,0.57-0.24,0.86c-0.03,0.14-0.07,0.28-0.09,0.42
			c-0.03,0.13-0.06,0.27,0.03,0.39c0.09,0.12,0.23,0.12,0.37,0.1c0.16-0.02,0.32-0.05,0.48-0.08c0.06-0.01,0.11-0.07,0.13-0.13
			c0.21-0.73,0.51-1.44,0.87-2.12c0.06-0.1,0.01-0.24-0.11-0.28c-0.28-0.07-0.59-0.13-0.87-0.01c-0.31,0.14-0.39,0.46-0.4,0.77
			c-0.01,0.17,0.2,0.23,0.32,0.13c0.19-0.17,0.38-0.34,0.58-0.51c-0.1-0.08-0.2-0.15-0.29-0.23c-0.15,0.35-0.3,0.7-0.46,1.05
			c-0.08,0.17-0.15,0.35-0.23,0.52c-0.07,0.16-0.23,0.39-0.12,0.55c0.09,0.12,0.27,0.14,0.4,0.07c0.15-0.09,0.17-0.27,0.17-0.43
			c0-0.38-0.01-0.76-0.01-1.15c0-0.24-0.38-0.24-0.37,0c0,0.25,0,0.49,0.01,0.74c0,0.12,0,0.23,0,0.35c0,0.05-0.01,0.12,0,0.16
			c0.01,0.03-0.03,0.01,0.01,0.01c0.03,0,0.06-0.05,0.09,0.02c0,0.06,0,0.13,0,0.19c0.27-0.63,0.55-1.26,0.82-1.89
			c0.08-0.19-0.13-0.38-0.29-0.23c-0.19,0.17-0.38,0.34-0.58,0.51c0.11,0.04,0.21,0.09,0.32,0.13c0.01-0.18,0.03-0.39,0.23-0.45
			c0.18-0.05,0.39,0,0.57,0.04c-0.04-0.09-0.07-0.18-0.11-0.28C27.86,7,27.55,7.74,27.33,8.5c0.04-0.04,0.09-0.09,0.13-0.13
			c-0.12,0.02-0.23,0.04-0.35,0.06c-0.02,0-0.13,0.01-0.14,0.02c0.03,0.08,0.05,0.1,0.06,0.06c0.01-0.03,0.01-0.06,0.02-0.09
			c0.05-0.23,0.1-0.45,0.16-0.68c0.06-0.22,0.11-0.43,0.18-0.64c0.06-0.17,0.13-0.32,0.27-0.44c0.08-0.06,0.07-0.2,0-0.27
			C27.58,6.32,27.47,6.34,27.39,6.4L27.39,6.4z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#EAD5A0' }}
            d="M27.05,8.81c0.02,0.1-0.02,0.23-0.05,0.34c-0.03,0.12-0.07,0.25-0.08,0.38c-0.02,0.24,0.07,0.5,0.3,0.61
			c0.21,0.11,0.47,0.09,0.66-0.04c0.21-0.14,0.32-0.37,0.35-0.61c0.03-0.24-0.01-0.51-0.16-0.71c-0.17-0.22-0.45-0.33-0.71-0.21
			c-0.24,0.11-0.35,0.39-0.34,0.64c0.01,0.27,0.11,0.55,0.26,0.78c0.09,0.14,0.26,0.23,0.42,0.13c0.14-0.09,0.16-0.28,0.18-0.43
			c0.04-0.29-0.01-0.59-0.12-0.86c-0.03-0.06-0.06-0.11-0.13-0.13c-0.06-0.02-0.14,0-0.18,0.05c-0.22,0.26-0.31,0.62-0.21,0.95
			c0.03,0.1,0.13,0.16,0.23,0.13c0.1-0.03,0.16-0.13,0.13-0.23c-0.01-0.03-0.02-0.06-0.02-0.09c0-0.01,0-0.03,0-0.01
			c0-0.02,0-0.03,0-0.05c0-0.03,0-0.06,0-0.09c0,0,0.01-0.05,0-0.03c0,0.02,0.01-0.03,0.01-0.03c0.01-0.03,0.01-0.06,0.02-0.08
			c0.01-0.02,0.01-0.03,0.02-0.05c-0.01,0.02,0,0,0-0.01c0.01-0.03,0.03-0.06,0.05-0.09c0.01-0.01,0.01-0.02,0.02-0.03
			c0.03-0.05-0.02,0.02,0.02-0.02c-0.1-0.03-0.21-0.06-0.31-0.08c0.08,0.18,0.12,0.36,0.12,0.55c0,0.1-0.01,0.18-0.02,0.27
			c0,0.02-0.01,0.04-0.01,0.06c0,0-0.01,0.03,0,0.01c0-0.02,0,0,0,0.01c0.03-0.03,0.06-0.04,0.1-0.03c0.02,0,0.02,0.01,0.04,0.01
			c0.01,0,0.01,0.02,0,0c-0.1-0.16-0.18-0.35-0.2-0.54c-0.01-0.08-0.01-0.16,0.02-0.24C27.41,9.05,27.43,9.01,27.44,9
			c0.01-0.02,0.02-0.03,0.03-0.05c-0.02,0.02,0.02-0.02,0.02-0.02c0.01-0.01,0.01-0.01,0.02-0.02c-0.02,0.01-0.01,0,0,0
			c0.01,0,0.05-0.02,0.02-0.01c0.01,0,0.06-0.01,0.05-0.01c-0.02,0,0.01,0,0.01,0c0.01,0,0.02,0,0.03,0c0.02,0,0,0,0,0
			c0.02,0,0.03,0.01,0.05,0.01c0.02,0.01,0,0,0,0c0.01,0,0.02,0.01,0.03,0.01c0.01,0.01,0.04,0.03,0.04,0.02
			c0.02,0.02,0.05,0.05,0.06,0.07c0.04,0.07,0.07,0.14,0.08,0.23c0-0.02,0,0.02,0,0.03c0,0.02,0,0.04,0,0.06
			c0,0.04,0,0.09-0.01,0.13c0-0.03-0.01,0.03-0.01,0.04c0,0.02-0.01,0.04-0.01,0.06c-0.01,0.02-0.01,0.04-0.02,0.05
			c-0.01,0.02,0,0,0,0c-0.01,0.01-0.01,0.03-0.02,0.04c-0.02,0.04-0.03,0.05-0.05,0.07c-0.01,0.02-0.03,0.03-0.05,0.05
			c0,0-0.02,0.02-0.01,0.01c0.02-0.01-0.01,0.01-0.02,0.01c-0.02,0.01-0.03,0.02-0.05,0.03c0.03-0.01-0.01,0-0.02,0.01
			c-0.02,0.01-0.03,0.01-0.05,0.01c-0.01,0-0.04,0.01,0,0c-0.01,0-0.02,0-0.03,0c-0.02,0-0.03,0-0.05,0c-0.03,0,0.02,0.01-0.02,0
			c-0.02,0-0.04-0.01-0.05-0.01c-0.02-0.01,0,0,0.01,0c-0.01,0-0.02-0.01-0.03-0.01c-0.01,0-0.01-0.01-0.02-0.01
			c-0.02-0.01,0.02,0.02-0.01-0.01c-0.01-0.01-0.01-0.01-0.02-0.02c-0.02-0.02,0.01,0.02-0.01-0.01c-0.01-0.02-0.02-0.04-0.03-0.06
			c0.01,0.03,0,0,0-0.01c0-0.01-0.01-0.02-0.01-0.04c0,0-0.01-0.03,0-0.01c0,0.02,0-0.02,0-0.02c0-0.03,0-0.05,0-0.08
			c0-0.02,0-0.05,0.01-0.07c0,0,0,0.02,0,0c0-0.02,0.01-0.03,0.01-0.05c0.02-0.11,0.06-0.21,0.08-0.32
			c0.03-0.14,0.04-0.27,0.02-0.41c-0.02-0.1-0.14-0.16-0.23-0.13C27.07,8.61,27.03,8.71,27.05,8.81L27.05,8.81z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#F25641' }}
            d="M27.63,10.29c-0.26-0.04-0.53-0.07-0.77,0.04c-0.2,0.09-0.36,0.3-0.34,0.53c0.01,0.22,0.15,0.42,0.34,0.53
			c0.2,0.12,0.45,0.12,0.67,0.05c0.22-0.07,0.45-0.21,0.59-0.4c0.07-0.1,0.13-0.21,0.13-0.33c-0.01-0.14-0.08-0.26-0.2-0.34
			c-0.37-0.26-1.02-0.22-1.22,0.23c-0.09,0.21-0.06,0.46,0.11,0.62c0.16,0.15,0.39,0.19,0.6,0.15c0.21-0.04,0.4-0.19,0.54-0.36
			c0.08-0.1,0.15-0.2,0.19-0.32c0.05-0.15,0.01-0.29-0.09-0.4c-0.28-0.34-0.92-0.46-1.16-0.02c-0.1,0.19-0.1,0.43,0.07,0.58
			c0.16,0.15,0.41,0.17,0.62,0.16c0.24-0.02,0.48-0.13,0.53-0.39c0.04-0.24-0.08-0.47-0.29-0.59c-0.38-0.22-1.05-0.16-1.2,0.32
			c-0.04,0.12-0.02,0.24,0.03,0.36c0.04,0.09,0.18,0.11,0.26,0.07c0.09-0.06,0.11-0.16,0.07-0.26c0.01,0.03,0-0.02,0-0.03
			c0,0.03,0,0,0-0.01c0.01-0.06-0.02,0.03,0-0.02c0-0.01,0.01-0.02,0.01-0.04c-0.01,0.03,0.02-0.02,0.02-0.02
			c0.03-0.05-0.01,0.01,0.01-0.02c0.03-0.03,0.03-0.03,0.07-0.05c0.04-0.02,0.12-0.04,0.16-0.04c0.07,0,0.17,0,0.21,0.01
			c0.07,0.02,0.11,0.03,0.17,0.06c0.03,0.02,0.03,0.02,0.06,0.04c0.04,0.03-0.01-0.02,0.02,0.02c0.01,0.02,0.02,0.03,0.03,0.05
			c-0.01-0.03,0.01,0.07,0.01,0.03c0,0.02,0,0.04,0,0.05c0-0.03,0,0,0,0c-0.01,0.05,0.02-0.02-0.01,0.02
			c-0.02,0.03-0.01,0.01,0,0.01c-0.01,0.02-0.03,0.03-0.05,0.03c-0.11,0.03-0.27,0.03-0.37,0.01c-0.02,0-0.04-0.01-0.06-0.02
			c0.01,0,0.02,0.01-0.01,0c0,0-0.05-0.03-0.02-0.01c0,0-0.03-0.03-0.01,0c0-0.01-0.03-0.05-0.01-0.01c0-0.01-0.01-0.02-0.01-0.03
			c-0.01-0.05,0,0.04,0-0.01c0-0.04-0.01,0.03,0-0.01c0-0.02,0.01-0.03,0.01-0.05c0,0.01-0.02,0.03,0,0
			c0.01-0.01,0.02-0.03,0.03-0.04c0,0.01-0.02,0.02,0,0c0.01-0.01,0.02-0.02,0.04-0.04c-0.01,0.01-0.03,0.02,0,0
			c0,0,0.05-0.03,0.02-0.01c0.02-0.01,0.04-0.01,0.06-0.02c0.04-0.01,0.1-0.01,0.15,0.01c0.07,0.02,0.12,0.05,0.19,0.09
			c0.02,0.01,0.04,0.03,0.06,0.05c-0.01-0.01,0.04,0.04,0.03,0.03c-0.01-0.01,0.01,0.03,0.01,0.01c0-0.02,0,0.02,0,0.02
			c0-0.01-0.01,0.02-0.01,0.02c-0.02,0.04-0.05,0.08-0.07,0.12c-0.07,0.1-0.17,0.2-0.29,0.26c-0.03,0.02-0.02,0.01-0.01,0.01
			C27.52,11,27.5,11,27.48,11.01c0,0-0.05,0.01-0.03,0.01c0.03,0-0.03,0-0.03,0c-0.02,0-0.03,0-0.05,0c-0.01,0-0.05,0-0.01,0
			c-0.04,0-0.07-0.01-0.1-0.03c0.03,0.01,0,0,0,0c-0.02-0.01-0.03-0.02-0.04-0.03c-0.03-0.02-0.01-0.01,0,0
			c-0.01-0.01-0.02-0.02-0.04-0.04c0.03,0.03-0.03-0.06-0.01-0.02c-0.01-0.01-0.01-0.03-0.01-0.05c0-0.01,0-0.01,0,0
			c0-0.01,0-0.02,0-0.04c0,0.03,0,0,0-0.01c0-0.02,0.01-0.04,0.02-0.05c-0.01,0.03,0,0,0-0.01c0.01-0.02,0.02-0.03,0.03-0.05
			c-0.01,0.02,0-0.01,0.01-0.01c0.01-0.01,0.03-0.03,0.04-0.04c0.03-0.03,0.01-0.01,0.01-0.01c0.02-0.01,0.04-0.03,0.07-0.04
			c0.12-0.05,0.26-0.03,0.4,0.01c0.05,0.02,0.11,0.04,0.14,0.07c0.04,0.04,0.01,0.01,0.01,0.01c-0.01-0.03,0.02,0.03,0,0
			c0.01,0.01,0,0.03,0,0.01c0,0.01-0.01,0.03-0.01,0.04c0.01-0.01,0-0.01-0.01,0.01c-0.07,0.12-0.19,0.2-0.32,0.26
			c-0.13,0.07-0.29,0.11-0.42,0.07c-0.05-0.01-0.1-0.04-0.14-0.09c-0.01-0.01-0.02-0.02-0.03-0.03c-0.01-0.02-0.02-0.02-0.01-0.01
			c-0.01-0.01-0.01-0.02-0.02-0.03c-0.01-0.01-0.01-0.02-0.02-0.03c-0.01-0.02-0.01-0.02,0,0c0-0.01-0.01-0.02-0.01-0.03
			c0-0.01-0.01-0.03-0.01-0.04c0.01,0.04,0-0.02,0-0.03c0-0.03-0.01,0.04,0-0.01c0,0,0.02-0.05,0.01-0.02
			c0.01-0.02,0.02-0.03,0.03-0.05c-0.02,0.02,0.02-0.02,0.02-0.02c0.03-0.03-0.02,0.01,0.02-0.02c0.02-0.01,0.03-0.02,0.05-0.03
			c0.05-0.03-0.01,0,0.02-0.01c0.02-0.01,0.04-0.01,0.07-0.02c0.04-0.01,0.08-0.01,0.12-0.01c0.1,0,0.2,0.01,0.29,0.03
			c0.1,0.02,0.2-0.03,0.23-0.13C27.79,10.43,27.73,10.3,27.63,10.29L27.63,10.29z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#B4D1D1' }}
            d="M28.02,11.28c-0.49-0.04-1,0.16-1.32,0.53c-0.08,0.09-0.07,0.23,0.04,0.29c0.25,0.16,0.55,0.04,0.78-0.1
			c0.26-0.16,0.51-0.32,0.77-0.47c0.15-0.1,0.1-0.35-0.09-0.35c-0.55,0.01-1.1,0.27-1.44,0.7c-0.04,0.05-0.07,0.11-0.05,0.18
			c0.02,0.06,0.07,0.12,0.13,0.13c0.43,0.08,0.88-0.02,1.23-0.29c0.17-0.13,0.35-0.34,0.28-0.58c-0.07-0.23-0.37-0.33-0.55-0.16
			c-0.07,0.07-0.07,0.2,0,0.27c0.07,0.07,0.19,0.07,0.27,0c-0.01,0.01-0.03,0.02-0.05,0.02c-0.01,0-0.05-0.01-0.02,0
			c-0.04-0.01-0.01-0.01,0,0c0.01,0.01,0.01,0.01-0.01-0.01c0,0,0.01,0.01,0.01,0.01c0,0-0.01-0.01-0.01-0.01
			c0.01,0.02,0.01,0.02,0,0.01c-0.01-0.02,0-0.03-0.01,0c0.01-0.02-0.01,0.02,0,0.01c0-0.01-0.02,0.03-0.02,0.03
			c-0.06,0.09-0.18,0.17-0.29,0.23c-0.07,0.04-0.1,0.05-0.17,0.07c-0.06,0.02-0.13,0.04-0.2,0.05c-0.05,0.01-0.12,0.01-0.18,0.01
			c-0.07,0-0.14-0.01-0.19-0.02c0.03,0.1,0.06,0.21,0.08,0.31c0.15-0.19,0.31-0.33,0.53-0.44c0.19-0.1,0.43-0.15,0.64-0.16
			c-0.03-0.12-0.06-0.23-0.09-0.35c-0.23,0.14-0.45,0.28-0.68,0.42c-0.09,0.05-0.19,0.12-0.28,0.16c-0.02,0.01-0.04,0.01-0.06,0.02
			c-0.01,0-0.03,0.01-0.04,0.01c0.02,0,0.01,0-0.01,0c-0.01,0-0.03,0-0.04,0c0.02,0,0.01,0-0.01,0c-0.02-0.01-0.03-0.01-0.01,0
			c-0.01-0.01-0.02-0.01-0.04-0.02c0.01,0.1,0.03,0.2,0.04,0.29c0.27-0.31,0.65-0.45,1.06-0.42c0.1,0.01,0.19-0.09,0.19-0.19
			C28.2,11.36,28.12,11.29,28.02,11.28L28.02,11.28z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#A2BAB9' }}
            d="M28.23,11.58c-0.31,0.09-0.61,0.24-0.87,0.43c-0.07,0.05-0.13,0.1-0.2,0.16c-0.07,0.06-0.15,0.13-0.18,0.22
			c-0.07,0.2,0.09,0.36,0.28,0.39c0.18,0.03,0.38,0.01,0.56-0.03c0.16-0.03,0.32-0.08,0.46-0.16c0.13-0.08,0.25-0.2,0.29-0.35
			c0.04-0.15,0-0.32-0.11-0.44c-0.15-0.17-0.37-0.15-0.55-0.04c-0.18,0.1-0.35,0.21-0.53,0.32c-0.06,0.04-0.1,0.11-0.09,0.19
			c0.01,0.08,0.06,0.13,0.13,0.16c0.31,0.13,0.67,0.05,0.92-0.16c0.08-0.06,0.07-0.2,0-0.27c-0.08-0.08-0.19-0.06-0.27,0
			c-0.04,0.04,0.01-0.01-0.01,0.01c-0.01,0.01-0.03,0.02-0.04,0.02c-0.01,0.01-0.03,0.01-0.04,0.02c-0.01,0-0.04,0.02-0.01,0.01
			c-0.03,0.01-0.05,0.02-0.08,0.03c-0.01,0-0.03,0.01-0.04,0.01c0,0-0.05,0.01-0.03,0.01c0.02,0-0.03,0-0.03,0
			c-0.01,0-0.02,0-0.04,0c-0.03,0-0.06,0-0.09,0c0.03,0,0,0-0.01,0c-0.01,0-0.03-0.01-0.04-0.01c-0.03-0.01-0.06-0.02-0.09-0.03
			c0.01,0.11,0.03,0.23,0.04,0.34c0.12-0.07,0.24-0.15,0.37-0.22c0.06-0.04,0.12-0.07,0.18-0.11c0.03-0.01,0.03-0.02,0.05-0.02
			c-0.02,0,0.01,0,0.01,0c-0.03,0-0.03,0-0.01,0c0,0,0.01,0,0.01,0c-0.04-0.01-0.02-0.01,0,0c0.02,0.01-0.03-0.02-0.01,0
			c0.01,0.01,0.02,0.03,0,0c0,0.01,0.01,0.02,0.01,0.02c0.01,0.01,0.01,0.03,0-0.01c0,0.01,0.01,0.02,0.01,0.03
			c0.01,0.03,0,0,0-0.01c0,0.01,0,0.03,0,0.04c0,0.04,0.01-0.02,0,0c0,0.01-0.01,0.02-0.01,0.03c-0.01,0.02,0.02-0.03-0.01,0.01
			c-0.01,0.01-0.01,0.02-0.02,0.03c0.02-0.03-0.02,0.02-0.03,0.03c-0.01,0.01-0.02,0.02-0.03,0.02c0.03-0.02-0.01,0.01-0.02,0.01
			c-0.02,0.01-0.05,0.03-0.07,0.04c-0.01,0-0.04,0.02-0.01,0.01c-0.01,0-0.02,0.01-0.03,0.01c-0.06,0.02-0.12,0.04-0.18,0.05
			c-0.13,0.03-0.24,0.04-0.38,0.04c-0.03,0-0.07-0.01-0.1,0c-0.02,0,0.04,0.01,0,0c-0.01,0-0.02-0.01-0.03-0.01
			c0.01,0,0.02,0.02,0,0c0.01,0.01,0.02,0.02,0.03,0.03c0.01,0.02,0.02,0.05,0.01,0.07c0,0.02-0.02,0.03,0,0.01
			c0.09-0.08,0.18-0.16,0.26-0.22c0.23-0.17,0.47-0.28,0.73-0.36c0.1-0.03,0.16-0.13,0.13-0.23C28.43,11.62,28.32,11.55,28.23,11.58
			L28.23,11.58z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#C1D3D1' }}
            d="M28.33,12.58c-0.43-0.07-0.87,0.06-1.18,0.37c-0.05,0.05-0.07,0.14-0.04,0.2c0.03,0.07,0.09,0.11,0.17,0.12
			c0.29,0.04,0.6,0.07,0.88-0.05c0.26-0.11,0.45-0.32,0.48-0.61c0.01-0.11-0.1-0.18-0.19-0.19c-0.22-0.02-0.43-0.01-0.64,0.02
			c-0.1,0.02-0.16,0.14-0.13,0.23c0.03,0.11,0.13,0.15,0.23,0.13c0.04-0.01,0.06-0.01,0.11-0.01c0.05,0,0.1-0.01,0.14-0.01
			c0.1,0,0.19,0,0.29,0.01c-0.06-0.06-0.12-0.12-0.19-0.19c0-0.02,0-0.02,0,0c0,0.01-0.01,0.03-0.01,0.04c0,0-0.01,0.03-0.01,0.02
			c0.01-0.02-0.01,0.01-0.01,0.01c-0.01,0.02-0.02,0.04-0.04,0.06c0.02-0.03-0.02,0.02-0.02,0.02c-0.01,0.01-0.02,0.02-0.03,0.03
			c0,0-0.03,0.02-0.01,0.01c0.02-0.01-0.01,0.01-0.02,0.01c-0.01,0.01-0.02,0.01-0.03,0.02c-0.02,0.01-0.04,0.03-0.07,0.04
			c-0.01,0.01-0.02,0.01,0,0c-0.01,0.01-0.03,0.01-0.04,0.01c-0.11,0.04-0.2,0.04-0.32,0.04c-0.13,0-0.25-0.02-0.38-0.03
			c0.04,0.11,0.09,0.21,0.13,0.32c0.03-0.03,0.06-0.06,0.09-0.08c-0.03,0.02,0.03-0.02,0.03-0.02c0.02-0.01,0.03-0.02,0.05-0.03
			c0.04-0.02,0.07-0.04,0.11-0.06c0.02-0.01,0.02-0.01,0.01,0c0.01,0,0.02-0.01,0.03-0.01c0.02-0.01,0.04-0.01,0.06-0.02
			c0.04-0.01,0.08-0.02,0.12-0.03c0.02,0,0.04-0.01,0.05-0.01c-0.04,0.01,0.03,0,0.04,0c0.04,0,0.08,0,0.13,0c0.02,0,0.04,0,0.05,0
			c0.01,0,0.02,0,0.04,0c-0.02,0-0.02,0,0,0c0.1,0.02,0.21-0.03,0.23-0.13C28.48,12.72,28.43,12.6,28.33,12.58L28.33,12.58z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#EAD5A0' }}
            d="M27.77,13.42c0.05,0.14-0.02,0.29-0.02,0.43c0,0.15,0.06,0.31,0.19,0.4c0.12,0.09,0.29,0.09,0.42,0
			c0.12-0.09,0.19-0.23,0.22-0.37c0.04-0.16,0.06-0.36-0.02-0.51c-0.07-0.15-0.25-0.25-0.42-0.22c-0.1,0.02-0.19,0.08-0.21,0.19
			c-0.01,0.08,0.01,0.17,0,0.25c0,0.14-0.03,0.28-0.07,0.42c-0.09,0.31-0.27,0.59-0.52,0.81c-0.11,0.1-0.04,0.27,0.08,0.31
			c0.18,0.06,0.36,0.09,0.54,0.11c0.18,0.02,0.36-0.02,0.44-0.2c0.15-0.31,0.11-0.69-0.04-0.99c-0.08-0.15-0.3-0.1-0.34,0.04
			c-0.08,0.24-0.18,0.47-0.31,0.69c-0.12,0.21,0.2,0.4,0.32,0.19c0.15-0.25,0.26-0.51,0.35-0.78c-0.11,0.01-0.23,0.03-0.34,0.04
			c0.05,0.09,0.08,0.19,0.09,0.29c0.01,0.12-0.02,0.21-0.04,0.32c0,0-0.01,0.02,0,0.02c-0.04,0.02-0.13-0.01-0.18-0.01
			c-0.13-0.02-0.26-0.05-0.38-0.09c0.03,0.1,0.06,0.21,0.08,0.31c0.48-0.42,0.75-1.08,0.69-1.71c-0.03,0.05-0.06,0.11-0.09,0.16
			c0.04-0.03-0.01,0.01-0.01-0.01c0,0,0.03,0.02,0.03,0.02c0.02,0.04,0.01,0.13,0,0.19c-0.01,0.05-0.02,0.11-0.04,0.15
			c-0.01,0.02-0.03,0.05-0.04,0.07c0-0.01-0.01,0.01-0.01,0.01c0,0,0.03-0.01,0.01,0c-0.01,0-0.01,0,0,0c0.01,0-0.01-0.01-0.01-0.01
			c0.01,0.02,0,0.01,0-0.01c-0.01-0.04-0.02-0.07-0.02-0.12c0.01-0.17,0.07-0.33,0.01-0.5c-0.04-0.09-0.13-0.16-0.23-0.13
			C27.81,13.21,27.73,13.33,27.77,13.42L27.77,13.42z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#C69775' }}
          d="M17.99,33.86c-0.44,1.23-1.69,1.96-2.92,2.19c-0.09,0.02-0.18-0.07-0.13-0.16c0.46-0.72,0.86-1.48,1.19-2.27
		c-0.17,0.23-0.38,0.43-0.62,0.62c-0.12,0.09-0.25-0.05-0.16-0.16c0.43-0.54,0.81-1.12,1.11-1.74c-0.06,0.06-0.13,0.12-0.2,0.18
		c-0.11,0.09-0.25-0.04-0.16-0.16c0.54-0.68,0.88-1.48,1-2.33c0,0,0.1-0.96,0.31-1.23c0.47,0.53,0.57,1.83,0.68,2.68
		C18.19,32.25,18.26,33.12,17.99,33.86z"
        />
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M11.89,15.71c0.36,1.78-0.33,3.57-0.48,5.35c-0.16,1.87,0.02,3.74,0.21,5.6c0.04,0.38,0.64,0.38,0.6,0
			c-0.19-1.93-0.38-3.88-0.19-5.81c0.18-1.77,0.8-3.5,0.44-5.29C12.39,15.18,11.81,15.34,11.89,15.71L11.89,15.71z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#936A4E' }}
            d="M14.24,13.04c0.06,1.1-0.44,2.07-0.82,3.07c-0.36,0.95-0.62,1.93-0.74,2.94c-0.24,1.88,0.04,3.84,1.13,5.43
			c0.22,0.32,0.74,0.02,0.52-0.3c-1.13-1.64-1.32-3.67-0.98-5.59c0.17-0.96,0.47-1.87,0.83-2.77c0.36-0.9,0.72-1.79,0.66-2.78
			C14.82,12.65,14.22,12.65,14.24,13.04L14.24,13.04z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#AF4848' }}
            d="M21.76,14.29c0.87-0.19,1.75-0.37,2.65-0.36c0.87,0.01,1.72,0.19,2.53,0.5c0.27,0.1,0.39-0.33,0.12-0.43
			c-0.84-0.33-1.74-0.51-2.65-0.52c-0.94-0.01-1.86,0.18-2.77,0.37C21.36,13.91,21.48,14.35,21.76,14.29L21.76,14.29z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#AF4848' }}
            d="M22.83,13.27c1.03-0.14,2.08-0.14,3.11,0.02c0.12,0.02,0.24-0.03,0.28-0.16c0.03-0.11-0.04-0.26-0.16-0.28
			c-1.11-0.17-2.23-0.18-3.35-0.02c-0.12,0.02-0.19,0.17-0.16,0.28C22.59,13.24,22.71,13.28,22.83,13.27L22.83,13.27z"
          />
        </g>
      </g>
      <g>
        <path
          style={{ fill: '#EAD5A0' }}
          d="M16.48,8.92c-0.99,4.92-2.49,9.75-4.48,14.38c0.56-1.19,1.11-2.39,1.67-3.58c0.65-1.4,1.31-2.81,1.78-4.28
		c0.66-2.03,0.96-4.17,0.9-6.29"
        />
        <g>
          <path
            style={{ fill: '#EAD5A0' }}
            d="M16.3,8.87c-1,4.92-2.49,9.72-4.46,14.33c-0.09,0.22,0.22,0.41,0.32,0.19c1.08-2.31,2.26-4.61,3.15-7
			c0.87-2.32,1.28-4.76,1.22-7.24c-0.01-0.24-0.38-0.24-0.37,0c0.05,2.44-0.35,4.85-1.21,7.14c-0.88,2.36-2.05,4.63-3.12,6.91
			c0.11,0.06,0.22,0.13,0.32,0.19c1.98-4.65,3.49-9.47,4.5-14.42C16.71,8.74,16.35,8.64,16.3,8.87L16.3,8.87z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            style={{ fill: '#6D5D54' }}
            d="M17.35,8.18c-0.56-0.11-1.09,0.06-1.59,0.29c-0.49,0.23-0.93,0.5-1.21,0.98c-0.1,0.18,0.12,0.45,0.31,0.31
			c0.18-0.14,0.38-0.25,0.6-0.32c0.25-0.08,0.5-0.11,0.75-0.15c0.47-0.06,0.96-0.2,1.22-0.64c0.09-0.14-0.02-0.34-0.19-0.34
			c-0.45,0.01-0.88,0.12-1.28,0.31c-0.11,0.05-0.14,0.21-0.08,0.31c0.07,0.11,0.2,0.13,0.31,0.08c0.33-0.16,0.69-0.24,1.05-0.25
			c-0.06-0.11-0.13-0.23-0.19-0.34c-0.22,0.37-0.74,0.4-1.12,0.45c-0.47,0.06-0.9,0.21-1.28,0.49c0.1,0.1,0.21,0.21,0.31,0.31
			c0.23-0.4,0.6-0.61,1-0.8c0.39-0.19,0.84-0.36,1.28-0.27C17.51,8.67,17.63,8.23,17.35,8.18L17.35,8.18z"
          />
        </g>
      </g>
    </>
  </AvatarArtwork>
);

export default JackSparrowAvatarArtwork;
